const {
  NODE_PERMISSION,
  NODE_TYPE,
  ACT,
  DEFAULT_TEMPLATE,
  FILTER_UNSET,
  FUNCTION_SET,
} = require('../../constants');
const dayjs = require('dayjs');
const getTempAttr = require('./getTempAttr');
const shareDbCompat = require('./shareDbCompat');
const {
  conditionMatchPropsData,
  textSort,
  getTempPropEnumOption,
  propIsNull,
  isBetween,
} = require('../../operation');
const NodeEditor = require('./nodeEditor');
const { filterNumber } = require('../../operation');
const { NODE_DATA_OFFSET } = require('./block_def');
const md5 = require('md5');
const { Uint64LE } = require('int64-buffer');
const crypto = require('crypto-browserify');
const { isDelete } = require('./pinodeUtils');
const { getMatchingOriginProp, getQuoteOriginPropInfo } = require('@/core/src/shared/prop');
const { getViewSettingOptionWithGroup } = require('@/core/src/shared/view');
const { Base_Date_Format_Options: Date_Format_Options } = require('../../constants/prop');
const { deepCopy } = require('ali-oss/lib/common/utils/deepCopy');
const { takeOne } = require('../../shared/util');
// const { sortPiNode } = require('@/core/src/pi/utils/piNodeSort');

const EnableLog = !window?.location?.host?.endsWith('mylinkpi.com');

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function getCompatibleDate(t) {
  return new Date(t + 3600_000 * 8);
}

function calcDistance(w1, j1, w2, j2) {
  if (w1 === null || j1 === null || w2 === null || j2 === null || (w1 === w2 && j1 === j2))
    return 0;
  const r = 6378.137;
  const wh1 = (w1 * Math.PI) / 180;
  const jh1 = (j1 * Math.PI) / 180;
  const wh2 = (w2 * Math.PI) / 180;
  const jh2 = (j2 * Math.PI) / 180;
  const v1 = [Math.cos(wh1) * Math.cos(jh1), Math.cos(wh1) * Math.sin(jh1), Math.sin(wh1)];
  const v2 = [Math.cos(wh2) * Math.cos(jh2), Math.cos(wh2) * Math.sin(jh2), Math.sin(wh2)];
  const l1 = Math.sqrt(v1[1] * v1[1] + v1[2] * v1[2] + v1[0] * v1[0]);
  const l2 = Math.sqrt(v2[1] * v2[1] + v2[2] * v2[2] + v2[0] * v2[0]);
  const v3 = [];
  for (let i = 0; i < 3; i++) {
    v1[i] = (v1[i] * (l1 + l2)) / l1;
    v2[i] = (v2[i] * (l1 + l2)) / l2;
    v3.push(v1[i] - v2[i]);
  }
  const l3 = Math.sqrt(v3[1] * v3[1] + v3[2] * v3[2] + v3[0] * v3[0]);
  const a = Math.asin(l3 / 2 / (l1 + l2)) * 2;
  return a * r;
}

function sha256(a, encoding = 'hex') {
  const hash = crypto.createHash('sha256');
  hash.update(a);
  return hash.digest(encoding);
}

function UInt32LE(buf, offset = 0) {
  return (
    buf[offset + 3] * 0x1000000 + (buf[offset + 2] << 16) + (buf[offset + 1] << 8) + buf[offset]
  );
}

const B32 = 2 ** 32;
const B16 = 2 ** 16;

function Int32LE(buf, offset = 0) {
  if (buf[offset + 3] & 0x80) {
    return UInt32LE(buf, offset) - B32;
  } else {
    return UInt32LE(buf, offset);
  }
}

function UInt16LE(buffer, offset = 0) {
  return (buffer[offset + 1] << 8) + buffer[offset];
}

function Int16LE(buffer, offset = 0) {
  if (buffer[offset + 1] & 0x80) {
    return UInt16LE(buffer, offset) - B16;
  } else {
    return UInt16LE(buffer, offset);
  }
}

function concat(buf1, buf2) {
  const ret = new buf1.constructor(buf1.length + buf2.length);
  try {
    ret.set(buf1);
    ret.set(buf2, buf1.length);
  } catch (e) {
    debugger;
  }
  return ret;
}

const hexList = [];
const HexList = [];
for (let i = 0; i < 16; i++) {
  hexList.push(`0${i.toString(16)}`);
  HexList.push(`0${i.toString(16).toUpperCase()}`);
}
for (let i = 16; i < 256; i++) {
  hexList.push(i.toString(16));
  HexList.push(i.toString(16).toUpperCase());
}

function hex16(buf, offset = 0) {
  return `${hexList[buf[offset]]}${hexList[buf[offset + 1]]}${hexList[buf[offset + 2]]}${
    hexList[buf[offset + 3]]
  }${hexList[buf[offset + 4]]}${hexList[buf[offset + 5]]}${hexList[buf[offset + 6]]}${
    hexList[buf[offset + 7]]
  }${hexList[buf[offset + 8]]}${hexList[buf[offset + 9]]}${hexList[buf[offset + 10]]}${
    hexList[buf[offset + 11]]
  }${hexList[buf[offset + 12]]}${hexList[buf[offset + 13]]}${hexList[buf[offset + 14]]}${
    hexList[buf[offset + 15]]
  }`;
}

function HEX16(buf, offset = 0) {
  return `${HexList[buf[offset]]}${HexList[buf[offset + 1]]}${HexList[buf[offset + 2]]}${
    HexList[buf[offset + 3]]
  }${HexList[buf[offset + 4]]}${HexList[buf[offset + 5]]}${HexList[buf[offset + 6]]}${
    HexList[buf[offset + 7]]
  }${HexList[buf[offset + 8]]}${HexList[buf[offset + 9]]}${HexList[buf[offset + 10]]}${
    HexList[buf[offset + 11]]
  }${HexList[buf[offset + 12]]}${HexList[buf[offset + 13]]}${HexList[buf[offset + 14]]}${
    HexList[buf[offset + 15]]
  }`;
}

function unhex(str) {
  const arr = [];
  for (let i = 0; i < str.length; i += 2) {
    arr.push(parseInt(str.slice(i, i + 2), 16));
  }
  return Uint8Array.from(arr);
}

let utf8decoder = new TextDecoder();

const AES_256_CBC = { name: 'AES-CBC', length: 256 };
const USAGE = ['decrypt'];

const sortByColumnMap = {
  createTime: 'h',
  modifyTime: 'm',
  createUser: 'i',
  modifyUser: 'd',
  startTime: 'ms',
  endTime: 'me',
};

const TIME_ZONE = (function getTimeZone() {
  const d = new Date();
  return d.getHours() - d.getUTCHours();
})();

function getDayStamp(t) {
  let d = new Date(t);
  if (TIME_ZONE === 8) {
    return (
      t -
      (((d.getHours() * 60 + d.getMinutes()) * 60 + d.getSeconds()) * 1000 + d.getMilliseconds())
    );
  }
  t = t + 8 * 3600_000;
  d = new Date(t);
  return (
    t -
    (((d.getUTCHours() * 60 + d.getMinutes()) * 60 + d.getSeconds()) * 1000 + d.getMilliseconds()) -
    8 * 3600_000
  );
}

function convertFilterTime(filterTime) {
  let now = null;
  for (let key in filterTime) {
    if (Array.isArray(filterTime[key]) && filterTime[key].length > 2) {
      if (now === null) now = getDayStamp(Date.now());
      filterTime[key][0] = now - 86400_000 * filterTime[key][2];
      filterTime[key][1] = now + 86400_000;
    }
  }
  return filterTime;
}

function convertIndexProp(prop) {
  const ret = [];
  if (typeof prop !== 'object' || prop === null) return ret;
  if (Array.isArray(prop._sys_temp)) {
    if (typeof prop._sys_temp[0] === 'string') {
      ret.push(`q-${prop._sys_temp[0]}`);
    }
    if (Array.isArray(prop._sys_temp[1])) {
      const props = [...prop._sys_temp[1]];
      for (let i = 0; i < props.length; i++) {
        if (typeof props[i] === 'object' && props[i] !== null && 'props' in props[i]) {
          if (Array.isArray(props[i].props)) {
            props[i] = props[i].props.flatMap((n) => n.value);
          } else {
            props[i] = props[i].props.values;
          }
        }
        if (!Array.isArray(props[i])) {
          props[i] = [props[i]];
        }
        props[i] = props[i].filter((n) => n !== null && n !== undefined);
        if (props[i].length > 0) {
          props[i].forEach((n) => ret.push(`p${i}-${String(n)}`));
        }
      }
    }
    if (typeof prop._sys_task_status === 'object' && prop._sys_task_status !== null) {
      if (typeof prop._sys_task_status.index === 'number') {
        ret.push(`si-${prop._sys_task_status.index}`);
      }
      if (Array.isArray(prop._sys_task_status.prop)) {
        const props = [...prop._sys_task_status.prop];
        for (let i = 0; i < props.length; i++) {
          if (typeof props[i] === 'object' && props[i] !== null && 'props' in props[i]) {
            if (Array.isArray(props[i].props)) {
              props[i] = props[i].props.flatMap((n) => n.value);
            } else {
              props[i] = props[i].props.values;
            }
          }
          if (!Array.isArray(props[i])) {
            props[i] = [props[i]];
          }
          props[i] = props[i].filter((n) => n !== null && n !== undefined);
          if (props[i].length > 0) {
            props[i].forEach((n) => ret.push(`s${i}-${String(n)}`));
          }
        }
      }
    }
  }
  if (typeof prop._sys_tag === 'object' && prop._sys_tag !== null) {
    ret.push.apply(
      ret,
      Object.keys(prop._sys_tag).map((n) => `t-${n}`),
    );
  }
  return ret;
}

/*
o: B2S(data.o), // 组织id
n: B2s(data.n), // 节点id
c: B2s(data.c), // 第一个子节点
e: JSON.parse(data.e), // 属性
d: B2S(data.d), // 修改者
f: L2N(data.f), // 分区号
g: data.g, // 节点类型
h: L2N(data.h), // 创建时间
i: B2S(data.i), // 创建人
j: B2s(data.j), // 弟节点
l: L2N(data.l), // 节点层数
m: L2N(data.m), // 修改时间
me: L2N(data.me), // 状态结束时间
mg: JSON.parse(data.mg), // 参与者
ms: L2N(data.ms), // 状态开始时间
mu: JSON.parse(data.mu), // 负责人
p: B2s(data.p), // 父节点id
q: B2S(data.q), // 模板id
r: L2N(data.r), // 模板状态
s: B2s(data.s), // 最后一个子节点
t: (B2S(data.o) === testOrg)?`${L2N(data.f)}-${data.t}`:String(data.t), // 标题
v: L2N(data.v), // 版本号
x: B2s(data.x), // 兄节点
iH: 1, // 是否隐藏
cn: 111 // 子节点数量
*/

const FILTER_SELF_ID = '3C9AB6B1596E0B10D0981A47C0D37F86';

const ClientList = {
  web: 'web',
  wxApplet: 'wxApplet',
  ios: 'ios',
};

const default_user_acl = {
  [ACT.文档编辑]: true,
  [ACT.大纲编辑]: true,
  [ACT.大纲管理]: true,
  [ACT.文档查看]: true,
};

function objectHasKey(o) {
  for (let i in o) {
    return true;
  }
  return false;
}

function valueIsNumber(o) {
  for (let i in o) {
    return typeof o[i] === 'number';
  }
  return true;
}

function convertDateTime(t, interval = 'day') {
  switch (interval) {
    case 'year':
      return dayjs(t).format('YYYY');
    case 'mon':
      return dayjs(t).format('YYYY/MM');
    case 'hour':
      return dayjs(t).format('YYYY/MM/DD HH:00');
    case 'min':
      return dayjs(t).format('YYYY/MM/DD HH:mm');
    case 'day':
    default:
      return dayjs(t).format('YYYY/MM/DD');
  }
}

const emptyArray = [];

class PiNode {
  constructor(nodeManager, node_id) {
    this.nodeManager = nodeManager;
    const i = node_id.split('_');
    if (i.length > 1) {
      // 虚拟节点
      this.node_id = i[i.length - 1];
      this._sys_node_type = 5;
    } else {
      if (this.nodeManager.hasData(node_id)) {
        this.node_id = node_id;
      } else {
        console.error(node_id);
        throw new Error('not find data');
      }
    }
  }

  get id() {
    return this.node_id;
  }

  set id(k) {
    console.error('cannot set id', this.node_id, k);
  }

  get orgId() {
    return this.metadata.o;
  }

  get data() {
    return this.nodeManager.getData(this.node_id);
  }

  get setData() {
    return this.nodeManager.setData(this.node_id);
  }

  get nodeType() {
    if (typeof this._sys_node_type === 'number') {
      return this._sys_node_type;
    }
    if (typeof this.data.e._sys_node_type === 'number') {
      return this.data.e._sys_node_type;
    }
    return this.node_id === this.nodeManager._toBeSortId ? 2 : 0;
  }

  get delete() {
    return isDelete(this.data);
  }

  get level() {
    if (this.data._level !== undefined) return this.data._level;
    let ret;
    if (this.nodeManager.hasData(this.data.p)) {
      const n = this.nodeManager.getNode(this.data.p);
      ret = n.level + 1;
    } else {
      ret = 0;
    }
    this.data._level = ret;
    return ret;
  }

  set level(l) {
    this.data._level = l;
    const children = this.children;
    for (let i = 0; i < children.length; i++) {
      children[i].level = l + 1;
    }
  }

  get createTime() {
    return this.data.h;
  }

  get creator() {
    return this.data.i;
  }

  get prop() {
    return this.data.e || {};
  }

  get template() {
    return this.nodeManager._template[this.data.q || this.data.e?._sys_temp?.[0]];
  }

  get title() {
    if (!this.data) {
      return '';
    }
    if ('_sys_filter' in this.data.e && this.data.t in this.nodeManager._allUser)
      return this.nodeManager._allUser[this.data.t];
    return this.data.t || '';
  }

  // nodeType = 0 and other ; 标准节点
  //            1 ; 回收站
  //            2 ; 待整理
  //            3 ; 筛选器根节点
  //            4 ; 筛选器路径节点
  //            5 ; 筛选器叶子节点

  get color() {
    return this.prop._sys_color;
  }

  get metadata() {
    return this.data || {};
  }

  get childInitDone() {
    return this._hasChild;
  }

  get firstChild() {
    return this.nodeManager.getNode(this.data.c);
  }

  get parentIndex() {
    return Object.keys(this.nodeManager.getParentIndex(this.id)).map((n) =>
      this.nodeManager.getNode(n),
    );
  }

  get children() {
    if (this.node_id in this.nodeManager._childrenCache) {
      return this.nodeManager._childrenCache[this.node_id];
    }
    if (this.prop._sys_ignore_children) {
      if (this.nodeManager.hasParentIndex(this.node_id)) {
        this.nodeManager._indexCache[this.node_id] = {};
        this.nodeManager._childrenCache[this.node_id] = this.nodeManager
          .getParentIndex(this.node_id)
          .map((n, index) => {
            this.nodeManager._indexCache[this.node_id][n] = index;
            return this.nodeManager.getNode(n);
          });
        return this.nodeManager._childrenCache[this.node_id];
      } else {
        return emptyArray;
      }
    }
    if (!this._hasChild) {
      // this.nodeManager._childrenCache[this.node_id] = [];
      return emptyArray;
    }
    const ret = [];
    const iE = {};
    iE[this.id] = true;
    let error = false;
    if (this.data.c !== null && this.nodeManager.getData(this.data.c)?.p === this.node_id) {
      let nextNode = this.nodeManager.getNode(this.data.c);
      if (!(nextNode.delete && !this.delete) && !nextNode.isHide) ret.push(nextNode);
      iE[this.data.c] = true;
      while (nextNode.hasNext) {
        const next = nextNode.next;
        nextNode = this.nodeManager.getNode(next);
        if (
          next in iE ||
          !this.nodeManager.hasData(next) ||
          (typeof this.nodeManager.getData(next).p === 'string' &&
            this.nodeManager.getData(next).p.length === 32 &&
            this.nodeManager.getData(next).p !== this.node_id)
        ) {
          if (EnableLog) {
            if (next in iE) {
              console.warn('iE', this.nodeManager.getNode(next));
            } else if (!this.nodeManager.hasData(next)) {
              console.warn('no data', next);
            } else {
              console.warn('p!==node_id', this.nodeManager.getData(next)?.p, this.node_id);
            }
          }
          error = true;
          break;
        }
        iE[next] = true;
        if (!(nextNode.delete && !this.delete) && !nextNode.isHide) ret.push(nextNode);
      }
    }
    const parentIndex = {};
    if (this.nodeManager.hasParentIndex(this.node_id))
      Object.assign(parentIndex, this.nodeManager.getParentIndex(this.node_id));
    if (
      this.node_id === this.nodeManager._rootId &&
      (!Array.isArray(this.nodeManager._orgOption.disWild) ||
        this.nodeManager._orgOption.disWild.includes(this.nodeManager._role))
    ) {
      // console.log("get children for root");
      Object.assign(parentIndex, this.nodeManager._wildNode);
      for (let node_id in this.nodeManager._wildNode) {
        if (this.nodeManager.hasData(node_id)) {
          this.nodeManager.getData(node_id).p = this.node_id;
        }
      }
      if (this.nodeManager.hasParentIndex(null))
        Object.assign(parentIndex, this.nodeManager.getParentIndex(null));
    }
    if (this.node_id in parentIndex) delete parentIndex[this.node_id];
    if (this.nodeManager._org_id === '5634AE61F150484EB2E5A2E46BCF7FC5') {
      for (let node_id in parentIndex) {
        if (!(node_id in iE)) {
          if (!this.nodeManager.getData(node_id).t.startsWith('【野】')) {
            this.nodeManager.getData(node_id).t = '【野】' + this.nodeManager.getData(node_id).t;
          }
        }
      }
    }
    for (let node_id in parentIndex) {
      if (!(node_id in iE)) {
        const stack = [];
        let x = this.data.x;
        while (x !== null && this.nodeManager.hasData(x) && !(x in iE)) {
          const node = this.nodeManager.getNode(x);
          if (!node.isHide && node.data.f >= 0 && node.data.p === this.node_id) {
            if (!(node.delete && !this.delete)) stack.push(node);
          }
          iE[x] = true;
          x = node.data.x;
        }
        if (stack.length > 0) ret.push.apply(ret, stack.reverse());
        if (
          !(node_id in iE) &&
          !this.nodeManager.getData(node_id).iH &&
          this.nodeManager.isRead(this.nodeManager.getData(node_id).e) &&
          this.nodeManager.getData(node_id).f >= 0 &&
          this.nodeManager.getData(node_id).p === this.node_id
        ) {
          const node = this.nodeManager.getNode(node_id);
          if (!(node.delete && !this.delete) && !node.isHide) ret.push(node);
          iE[node_id] = true;
        }
        let j = this.nodeManager.getData(node_id).j;
        while (j !== null && this.nodeManager.hasData(j) && !(j in iE)) {
          if (
            !this.nodeManager.getData(j).iH &&
            this.nodeManager.isRead(this.nodeManager.getData(j).e) &&
            this.nodeManager.getData(j).f >= 0 &&
            this.nodeManager.getData(j).p === this.node_id
          ) {
            const node = this.nodeManager.getNode(j);
            if (!(node.delete && !this.delete) && !node.isHide) ret.push(node);
          }
          iE[j] = true;
          j = this.nodeManager.getData(j).j;
        }
      }
    }
    this.nodeManager._childrenCache[this.node_id] = [...ret];
    this.nodeManager._indexCache[this.node_id] = {};
    const l = this.level + 1;
    for (let i = 0; i < ret.length; i++) {
      this.nodeManager._indexCache[this.node_id][ret[i].id] = i;
      ret[i].level = l;
      if (i > 0) {
        if (ret[i].data.x !== ret[i - 1].id) {
          if (EnableLog) console.warn(ret[i].data.n, 'x', ret[i].data.x, ret[i - 1].id);
          ret[i].setData.x = ret[i - 1].id;
          error = true;
        }
      } else {
        if (ret[i].data.x !== null) {
          if (EnableLog) console.warn(ret[i].data.n, 'x', ret[i].data.x, null);
          ret[i].setData.x = null;
          error = true;
        }
      }
      if (i < ret.length - 1) {
        if (ret[i].data.j !== ret[i + 1].id) {
          if (EnableLog) console.warn(ret[i].data.n, 'j', ret[i].data.j, ret[i + 1].id);
          ret[i].setData.j = ret[i + 1].id;
          error = true;
        }
      } else {
        if (ret[i].data.j !== null) {
          if (EnableLog) console.warn(ret[i].data.n, 'j', ret[i].data.j, null);
          ret[i].setData.j = null;
          error = true;
        }
      }
    }
    if (ret.length) {
      if (
        (this.data.c !== ret[0].data.n && this.data.c !== this.nodeManager._toBeSortId) ||
        this.data.s !== ret[ret.length - 1].data.n
      ) {
        if (EnableLog)
          console.warn('c/s', this.data.c, ret[0].data.n, this.data.s, ret[ret.length - 1].data.n);
        error = true;
      }
    } else {
      if (
        (this.nodeManager.hasData(this.data.c) && this.data.c !== null) ||
        (this.nodeManager.hasData(this.data.s) && this.data.s !== null)
      ) {
        if (EnableLog) console.warn('c/s', this.data.c, this.data.s);
        error = true;
      }
    }
    if (
      error &&
      !this.prop._sys_filter &&
      !this.prop._sys_collection &&
      !this.prop._sys_hideChildren &&
      !this.nodeManager._role < 7 &&
      this.nodeManager._accountId !== '5F87B6C22D9E11EC8C496C92BF5C7582' &&
      ret.every((n) => n.data.f < 3)
    ) {
      console.log('resort', this.node_id);
      this.nodeManager._reSortTask.push(this.node_id);
      setTimeout(this.nodeManager.uploadOp.bind(this.nodeManager), 1000, true);
    }
    return ret;
  }

  get all_children() {
    const children = this.children;
    const ret = [...children];
    for (const child of children) {
      ret.push.apply(ret, child.all_children);
    }
    return ret;
  }

  get childrenTotalCount() {
    const children = this.children;
    let ret = children.length;
    for (let i = 0; i < children.length; i++) {
      ret += children[i].childrenTotalCount;
    }
    return ret;
  }

  /*get testSort() {
    return sortPiNode(
      this.all_children,
      Object.values(this.nodeManager._template).map((n) => ({
        theme: n.template_id,
        sortDepends: [
          { order: 'asc', value: 'template' },
          { order: 'asc', value: 'title' },
          { order: 'asc', value: 'treeLevel' },
        ],
      })),
    ).map((n) => `${n.metadata.e._sys_temp?.[0]}/${n.metadata.t}`);
  }*/

  getMatchNode(node_id, groupBy, interval, draft = false) {
    // console.log('getMatchNode', this.prop._sys_filter, groupBy, node_id);
    /*console.log(
      'getMatchNode start',
      this.id,
      this.children.map((n) => n.id),
    );*/
    const orgGroupBy = this.prop._sys_filter?.groupBy;
    if (!(Array.isArray(orgGroupBy) && orgGroupBy.length === groupBy.length)) return [];
    if (!this.nodeManager.hasData(node_id)) return [];
    const n = this.nodeManager.getNode(node_id).metadata;
    const group = this.nodeManager.getNodeGroup(n, groupBy, [], interval);
    const ret = new Set();
    for (let i = 0; i < group.length; i++) {
      let select_node_id = this.id;
      for (let j = 0; j < group[i].length; j++) {
        select_node_id =
          select_node_id + `>${orgGroupBy[j]}-${this.nodeManager.encodeNodeId(group[i][j])}`;
      }
      if (this.nodeManager.hasData(select_node_id)) {
        for (const n of this.nodeManager.getData(select_node_id).e._sys_filter_node) {
          if (!ret.has(n)) ret.add(n);
        }
      }
    }
    const r = [];
    if (draft) {
      for (const n of ret) {
        if (!this.nodeManager.hasData(n)) continue;
        const f = this.nodeManager.getData(n).f;
        if (f >= 0 ? f !== 2 : f === -2) {
          try {
            r.push(this.nodeManager.getNode(n));
          } catch (e) {
            console.error(e);
          }
        }
      }
    } else {
      for (const n of ret) {
        if (!this.nodeManager.hasData(n)) continue;
        const f = this.nodeManager.getData(n).f;
        if (f >= 0 && f !== 2) {
          try {
            r.push(this.nodeManager.getNode(n));
          } catch (e) {
            console.error(e);
          }
        }
      }
    }
    let node_list = Array.from(r);
    const serial_number = this.nodeManager.getNodeTreeSerialNumber(node_list);
    node_list = textSort(node_list, (n) => serial_number[n.id], true);
    // console.log('getMatchNode', n, this, groupBy, group, r);
    /*for (const node of node_list) {
      console.log(serial_number[node.id], node.title);
    }*/
    return node_list;
  }

  get index() {
    if (this.data.p === null || this.data.p.toUpperCase() === `${this.nodeManager._org_id}DD`)
      return 0;
    if (!(this.data.p in this.nodeManager._indexCache)) {
      this.getParentNode()?.children;
    }
    return this.nodeManager._indexCache[this.data.p]?.[this.id] || 0;
  }

  get isSystemSpecial() {
    return (
      this.node_id === this.nodeManager._rootId ||
      this.node_id === this.nodeManager._toBeSortId ||
      this.prop._sys_collect_root ||
      this.prop._sys_collection ||
      this.prop._sys_filter ||
      this.prop._sys_form
    );
  }

  get _hasChild() {
    if (this.nodeType === 5) return false;
    if (this.data.c !== null) return true;
    return !!this.nodeManager.hasParentIndex(this.node_id);
  }

  get hasChild() {
    if (this.nodeType === 5) return false;
    return this.childrenLength > 0;
  }

  get originNext() {
    return this.nodeManager.getNode(this.nodeManager._data[this.node_id].j);
  }

  get hasOriginNext() {
    return (
      this.nodeManager._data[this.node_id].j !== null &&
      this.nodeManager.hasData(this.nodeManager._data[this.node_id].j)
    );
  }

  get next() {
    return this.data.j;
  }

  get hasNext() {
    return this.data.j !== null && this.nodeManager.hasData(this.data.j);
  }

  get isHide() {
    if (this.nodeManager._toBeSortId === this.id) {
      if ((this.nodeManager.getRoot().prop._sys_function & FUNCTION_SET.CLEARING) === 0) {
        return true;
      }
    } else if (
      this.nodeManager._org_id !== 'FD35DEB6D0E9786DDB03D49ED957620C' &&
      this.id === this.nodeManager.getNode(this.nodeManager._rootId)?.prop?._sys_org_struct?.node
    ) {
      return true;
    }
    let ret = !!(this.data.iH || `_sys_${this.nodeManager._client}_hide` in this.data.e);
    if (this.nodeManager._role === 7) {
      if (!ret && '_sys_collection' in this.data.e) {
        let f = true;
        const children = this.children;
        for (let i = 0; i < children.length; i++) {
          if (!children[i].isHide) {
            f = false;
            break;
          }
        }
        return f;
      }
      return ret || !this.nodeManager.isRead(this.prop);
    }
    return ret;
  }

  get document() {
    return {
      id: `Doc${this.node_id}`,
      _cover: this.prop._sys_cover || [],
    };
  }

  get isCompleted() {
    return false;
  }

  get actions() {
    // if (!('e' in this.data)) {
    //   console.log(this.node_id, this.data);
    // }
    return this.prop._sys_actions || [];
  }

  get acl() {
    if (this.isHide) return NODE_PERMISSION.不可见;
    if (this.nodeManager._accountId === '5F87B6C22D9E11EC8C496C92BF5C7582')
      return NODE_PERMISSION.只读;
    if (this.nodeManager.isManage(this.prop)) return NODE_PERMISSION.管理;
    if (this.nodeManager.isEditor(this.prop)) return NODE_PERMISSION.编辑;
    if (this.nodeManager.isSwitch(this.prop)) return NODE_PERMISSION.可转换;
    return NODE_PERMISSION.只读;
  }

  get isLeaf() {
    if (this.nodeType === 3 || this.nodeType === 4) {
      return false;
    }
    if (this.nodeType === 5) {
      return true;
    }

    // 默认通过是否有子节点判断
    return !this._hasChild;
  }

  get childrenLength() {
    const filterLength =
      typeof this.prop._sys_filter_node === 'object' &&
      this.prop._sys_filter_node?.constructor?.name === 'Set'
        ? this.prop._sys_filter_node.size
        : 0;
    if (typeof this.data?.cn === 'number') return filterLength + this.data.cn;
    const children = this.children;
    if (!children) return filterLength;
    let j = filterLength;
    for (let i = 0; i < children.length; i++) {
      if (!(children[i].delete || children[i].isHide)) j++;
    }
    return j;
  }

  get parent() {
    return this.getParentNode();
  }

  get key() {
    return this.node_id;
  }

  set key(k) {
    console.error('cannot set key', this.node_id, k);
  }

  get value() {
    return this.node_id;
  }

  get _document() {
    return this.document;
  }

  get hasChildren() {
    return this._hasChild;
  }

  get hasAttachment() {
    return this._hasAttachment || false;
  }

  set hasAttachment(n) {
    this._hasAttachment = n;
  }

  get timelineTime() {
    return this.createTime * 1000;
  }

  get status() {
    return this._status || 'normal';
  }

  set status(s) {
    this._status = s;
  }

  get isDelete() {
    return this.delete;
  }

  get node() {
    return this;
  }

  cleanLevel() {
    if (this.data._level !== undefined) {
      delete this.data._level;
    }
    const children = this.children;
    for (let i = 0; i < children.length; i++) {
      children[i].cleanLevel();
    }
  }

  updateProp(prop) {
    switch (this.acl) {
      case NODE_PERMISSION.不可见:
      case NODE_PERMISSION.只读:
        throw Error(`没有权限`);
      default:
        return this.nodeManager.updateProp(this.id, prop);
    }
  }

  insertNode(index, data = null, copy = null, draft = false) {
    return this.nodeManager.insert(this.id, index, data, copy, draft);
  }

  deleteNode(remove = false) {
    if (!this.parent) {
      return;
    }
    this.nodeManager.delete(this.id, remove);
  }

  moveNode(parent, index) {
    this.nodeManager.move(this.id, typeof parent === 'string' ? parent : parent.id, index);
  }

  // 是否是叶子节点
  // 通过这个判断是否可以展开

  //            0 ; 普通
  //            1 ; 回收站
  //            2 ; 待整理
  //            3 ; 过滤器根节点
  //            4 ; 过滤器路径节点
  //            5 ; 过滤器叶子节点

  setTitle(title) {
    this.nodeManager.setTitle(this.id, title);
  }

  setAction(prop) {
    this.nodeManager.setAction([this.id], prop);
  }

  path(root = null) {
    let p = this.data.p;
    const iE = new Set();
    const ret = [this.index];
    while (p !== root && p !== null && !iE.has(p)) {
      iE.add(p);
      const node = this.nodeManager.getNode(p);
      ret.unshift(node.index);
      p = node.data.p;
    }
    return ret;
  }

  getAcl(nodeId, groupInfo, userInfo) {
    // TODO
    // 查询当前节点所有被设置过的权限
    const ret = { user: [], group: [] };
    const path = this.findChildrenPath(nodeId);
    if (path === null) return null;
    const acl = { user: {}, group: {} };
    const groupLocate = {};
    const userLocate = {};
    const roleMap = {
      1: NODE_PERMISSION.管理,
      3: NODE_PERMISSION.管理,
      4: NODE_PERMISSION.编辑,
      5: NODE_PERMISSION.只读,
    };
    for (let i = 0; i < userInfo.length; i++) {
      userLocate[userInfo[i].account_id] = ret.user.length;
      ret.user.push({
        ...userInfo[i],
        acl: roleMap[userInfo[i].role],
        from: 'default',
      });
    }
    for (let i = 0; i < groupInfo.length; i++) {
      if (!groupInfo[i].group_id.startsWith('-')) {
        groupLocate[groupInfo[i].group_id] = ret.group.length;
        ret.group.push({
          ...groupInfo[i],
          acl: roleMap[groupInfo[i].role],
          from: 'default',
        });
      }
    }
    let node = this;
    let i = 0;
    while (i < path.length) {
      if ('_sys_c_user_acl' in node.prop) {
        for (let accountId in node.prop._sys_c_user_acl) {
          acl.user[accountId] = node.prop._sys_c_user_acl[accountId];
        }
      }
      if ('_sys_c_group_acl' in node.prop) {
        for (let groupId in node.prop._sys_c_group_acl) {
          acl.group[groupId] = node.prop._sys_c_group_acl[groupId];
        }
      }
      node = node.children[path[i]];
      i++;
    }
    if ('_sys_user_acl' in node.prop) {
      for (let accountId in node.prop._sys_user_acl) {
        acl.user[accountId] = node.prop._sys_user_acl[accountId];
      }
    }
    if ('_sys_group_acl' in node.prop) {
      for (let groupId in node.prop._sys_group_acl) {
        acl.group[groupId] = node.prop._sys_group_acl[groupId];
      }
    }
    for (let id in acl.user) {
      if (id in userLocate) {
        if (ret.user[userLocate[id]].acl !== NODE_PERMISSION.管理) {
          if (ACT.不可见 in acl.user.id && acl.user.id[ACT.不可见]) {
            Object.assign(ret.user[userLocate[id]], {
              acl: NODE_PERMISSION.不可见,
              from: id in node.prop._sys_user_acl ? 'node' : 'parent',
            });
          } else if (ACT.大纲管理 in acl.user.id && acl.user.id[ACT.大纲管理]) {
            Object.assign(ret.user[userLocate[id]], {
              acl: NODE_PERMISSION.管理,
              from: id in node.prop._sys_user_acl ? 'node' : 'parent',
            });
          } else if (
            ret.user[userLocate[id]].acl !== NODE_PERMISSION.编辑 &&
            ACT.大纲编辑 in acl.user.id &&
            acl.user.id[ACT.大纲编辑]
          ) {
            Object.assign(ret.user[userLocate[id]], {
              acl: NODE_PERMISSION.编辑,
              from: id in node.prop._sys_user_acl ? 'node' : 'parent',
            });
          }
        }
      }
    }
    for (let id in acl.group) {
      if (id in groupLocate) {
        if (ret.group[groupLocate[id]].acl !== NODE_PERMISSION.管理) {
          if (ACT.不可见 in acl.group.id && acl.group.id[ACT.不可见]) {
            Object.assign(ret.group[groupLocate[id]], {
              acl: NODE_PERMISSION.不可见,
              from: id in node.prop._sys_group_acl ? 'node' : 'parent',
            });
          } else if (ACT.大纲管理 in acl.group.id && acl.group.id[ACT.大纲管理]) {
            Object.assign(ret.group[groupLocate[id]], {
              acl: NODE_PERMISSION.管理,
              from: id in node.prop._sys_group_acl ? 'node' : 'parent',
            });
          } else if (
            ret.group[groupLocate[id]].acl !== NODE_PERMISSION.编辑 &&
            ACT.大纲编辑 in acl.group.id &&
            acl.group.id[ACT.大纲编辑]
          ) {
            Object.assign(ret.group[groupLocate[id]], {
              acl: NODE_PERMISSION.编辑,
              from: id in node.prop._sys_group_acl ? 'node' : 'parent',
            });
          }
        }
      }
    }
    return ret;
  }

  toJsonDoc() {
    // 尽量不要用
    // 获取当前所有载入节点的json格式内容
  }

  toString() {
    // TODO
  }

  toAntDTreeData(expandKeys = [], spaceType, filterHide = true, root = true) {
    if (typeof expandKeys === 'string') {
      if (expandKeys === this.node_id) {
        expandKeys = [this.node_id];
      } else {
        return null;
      }
    } else if (Array.isArray(expandKeys)) {
      if (
        expandKeys.length &&
        !expandKeys.includes(this.node_id) &&
        !expandKeys.includes(this.data.p)
      ) {
        return null;
      }
    } else {
      expandKeys = [];
    }
    let item = null;
    if (filterHide) {
      if (this.antDTreeDataH?.v === this.data.v) item = this.antDTreeDataH;
    } else {
      if (this.antDTreeData?.v === this.data.v) item = this.antDTreeData;
    }
    if (!item) {
      item = {
        key: this.node_id,
        value: this.node_id,
        id: this.node_id,
        title: this.title,
        acl: this.acl,
        nodeType: this.nodeType,
        _document: this.document,
        document: this.document,
        isCompleted: this.isCompleted,
        hasChildren: this._hasChild,
        children: [],
        hasAttachment: false,
        timelineTime: this.createTime * 1000,
        status: 'normal',
        spaceType: spaceType,
        prop: this.prop,
        isDelete: this.delete,
        isLeaf: this.isLeaf,
        metadata: this.metadata,
        node: this,
        v: this.data.v,
      };
      if (filterHide) {
        this.antDTreeDataH = item;
      } else {
        this.antDTreeData = item;
      }
    }
    /*if (root) {
      console.log(`start toAntDTreeData ${this.id}`);
    }*/
    // 隐藏子主题
    const hideChildren = this.prop?._sys_hideChildren;
    if (hideChildren) {
      item.isLeaf = true;
      item.hasChildren = false;
      item.children = [];
      return item;
    }

    if (this.childInitDone && (!expandKeys.length || expandKeys.includes(this.node_id))) {
      if (filterHide) {
        item.children = this.children
          .filter((node) => this.nodeManager.hasData(node.node_id) && !(node.isHide || node.delete))
          .map((node) => node.toAntDTreeData(expandKeys, spaceType, filterHide, false));
      } else {
        item.children = this.children
          .filter((node) => this.nodeManager.hasData(node.node_id))
          .map((node) => node.toAntDTreeData(expandKeys, spaceType, filterHide, false));
      }
    }
    if (
      typeof this.prop._sys_filter_node === 'object' &&
      this.prop._sys_filter_node?.constructor?.name === 'Set'
    ) {
      item.children = item.children.filter(
        (n) =>
          this.prop._sys_filter_node.has(n.id) &&
          this.nodeManager.hasData(n.id) &&
          !this.nodeManager.getNode(n.id).isHide &&
          !this.nodeManager.getNode(n.id).delete,
      );
      const iE = new Set();
      for (let i = 0; i < item.children.length; i++) {
        iE.add(item.children[i].key);
        if (this.nodeManager.getData(item.children[i].id).v !== item.children[i].v) {
          const node = this.nodeManager.getNode(item.children[i].key);
          item.children[i] = {
            key: item.children[i].key,
            value: item.children[i].key,
            id: item.children[i].id,
            title: node.title,
            acl: node.acl,
            nodeType: 5,
            _document: node.document,
            document: node.document,
            isCompleted: node.isCompleted,
            hasChildren: node._hasChild,
            children: emptyArray,
            hasAttachment: false,
            timelineTime: node.createTime * 1000,
            status: 'normal',
            spaceType: spaceType,
            prop: node.prop,
            isDelete: node.delete,
            isLeaf: true,
            v: node.data.v,
          };
        }
      }
      for (let node_id of this.prop._sys_filter_node) {
        if (!this.nodeManager.hasData(node_id)) continue;
        const newNodeId = `${this.node_id}_${node_id}`;
        if (iE.has(newNodeId)) continue;
        iE.add(newNodeId);
        const node = this.nodeManager.getNode(newNodeId);
        if (!node.isHide && !node.delete) {
          item.children.push({
            key: newNodeId,
            value: newNodeId,
            id: node_id,
            title: node.title,
            acl: node.acl,
            nodeType: 5,
            _document: node.document,
            document: node.document,
            isCompleted: node.isCompleted,
            hasChildren: node._hasChild,
            children: emptyArray,
            hasAttachment: false,
            timelineTime: node.createTime * 1000,
            status: 'normal',
            spaceType: spaceType,
            prop: node.prop,
            isDelete: node.delete,
            isLeaf: true,
            v: node.data.v,
          });
        }
      }
    }
    return item;
  }

  /* status:
  normal 普通灵感,
  action 行动,
  completed 完成的行动,
  task 任务,
  meeting 会议
  */
  getActionList(
    userDocRootId,
    spaceType,
    rootid = null,
    parentNodeType = null,
    templateList = null,
  ) {
    const ret = [];
    if (this.nodeManager.hasData(this.node_id)) {
      if (this.isHide) return ret;
      let item = {
        key: this.id,
        title: this.title,
        _document: this.document,
        document: this.document,
        isCompleted: this.isCompleted,
        hasChildren: this._hasChild,
        hasAttachment: false,
        color: this.color || '#3E8FF9',
        status: 'normal',
        rootid: this.nodeManager._rootId,
        spaceType,
        prop: this.prop,
        isDelete: this.delete,
        nodeType: this.nodeType,
      };
      const createTime = Number.isFinite(this.createTime)
        ? this.createTime * 1000 > Date.now() * 10
          ? this.createTime
          : this.createTime * 1000
        : null;
      if (!!createTime) {
        item['timelineTime'] = createTime;
      }
      if (Array.isArray(this.prop?._sys_temp)) {
        //模板节点
        item['status'] = 'action';
        if (
          Array.isArray(this.prop._sys_task_status?.prop) &&
          this.prop._sys_task_status?.prop.length >= 4
        ) {
          const template = templateList?.find(
            (template) => template.template_id === this.prop._sys_temp[0],
          );
          if (!!template && Array.isArray(template.task_status) && template.task_status.length) {
            if (template.task_status[this.prop._sys_task_status.index]?.isFinal) {
              item['status'] = 'completed';
            }
            // else if (
            //   !template.task_status.find(
            //     (status) => status.prevState === this.prop._sys_task_status.index,
            //   )
            // ) {
            //   item['status'] = 'completed';
            // }
          }
          item['type'] = 2;
          item['sender'] = this.prop._sys_task_status.sender || null;
          const task_prop = this.prop._sys_task_status.prop;
          if (
            this.prop._sys_temp[0] === DEFAULT_TEMPLATE &&
            this.prop._sys_task_status?.index === 2
          ) {
            item['owner'] = this.prop._sys_task_status.lastUser || null;
            item['startTime'] = this.prop._sys_task_status.lastStartTime || createTime;
          } else {
            item['endTime'] = task_prop[3] || null;
            if (!!task_prop[2]) {
              item['startTime'] = task_prop[2];
            } else if (!!this.prop._sys_task_status.sendTime) {
              item['startTime'] = this.prop._sys_task_status.sendTime;
            } else if (!!createTime) {
              item['startTime'] = createTime;
            }
            item['owner'] = task_prop[0] || null;
            item['participant'] = task_prop[1] || null;
          }
        }
      } else if (this.actions && this.actions.length > 0) {
        //兼容旧的任务数据
        const action = this.actions[0];
        item['status'] =
          action._startTime === null ? 'normal' : action._isCompleted ? 'completed' : 'action';
        if (!!action._startTime) {
          item['startTime'] = action._startTime;
        } else if (!!createTime) {
          item['startTime'] = createTime;
        }
        item['endTime'] = action._endTime;
        // item['timelineTime'] = action.startTime;
        // fix 如果action有startTime 才是有效action 不然是主题 只取节点createTime
        // if (action.startTime) {
        //   item['timelineTime'] = action.startTime;
        // }
        item['type'] = action._type;
        if ('_assigneeId' in action) {
          if (
            !!action._assigneeId?.owner &&
            action._assigneeId.owner?.length > 0 &&
            action._assigneeId.owner[0] !== null
          ) {
            item['owner'] = action._assigneeId.owner;
          }
          if (
            'user' in action._assigneeId &&
            action._assigneeId.user.length > 0 &&
            action._assigneeId.user[0] !== null
          ) {
            item['participant'] = action._assigneeId.user;
          }
        }
      }
      if (item.status === 'completed') {
        item.isCompleted = true;
      }
      if (!!item['startTime']) {
        item['timelineTime'] = item['startTime'];
        // if (!!item['endTime']) {//有设置结束时间
        //     if (item.status === 'action') {
        //         if (new Date().setHours(0, 0, 0) > new Date(item['startTime']).setHours(0, 0, 0)) {
        //             if (new Date().setHours(0, 0, 0) <= new Date(item['endTime']).setHours(0, 0, 0)) {
        //                 item['timelineTime'] = new Date().setHours(new Date(item['startTime']).getHours(), new Date(item['startTime']).getMinutes(), new Date(item['startTime']).getSeconds());
        //             } else {
        //                 item['timelineTime'] = new Date(item['endTime']).setHours(new Date(item['startTime']).getHours(), new Date(item['startTime']).getMinutes(), new Date(item['startTime']).getSeconds());
        //             }
        //         }
        //     } else if (item.status === 'completed' && new Date().setHours(0, 0, 0) > new Date(item['endTime']).setHours(0, 0, 0)) {
        //         item['timelineTime'] = new Date(item['endTime']).setHours(new Date(item['startTime']).getHours(), new Date(item['startTime']).getMinutes(), new Date(item['startTime']).getSeconds());
        //     }
        // } else {//未设置结束时间
        //     if (item.status === 'action' && new Date().getTime() > new Date(item['startTime']).getTime()) {
        //         item['timelineTime'] = new Date().setHours(new Date(item['startTime']).getHours(), new Date(item['startTime']).getMinutes(), new Date(item['startTime']).getSeconds());
        //     }
        // }
      }

      if (rootid === null) {
        rootid = this.nodeManager._org_id;
      } else {
        if (
          // (userDocRootId === rootid && parentNodeType === NODE_TYPE.CLEARING) || (
          item.status !== 'normal' &&
          ((!!item['owner'] && ~item['owner'].indexOf(this.nodeManager._accountId)) ||
            (!!item['participant'] && ~item['participant'].indexOf(this.nodeManager._accountId))) &&
          !!item['timelineTime']
          // )
        ) {
          ret.push(item);
        }
      }
      const children = this.children;
      for (let i = 0; i < children?.length; i++) {
        ret.push.apply(
          ret,
          children[i].getActionList(userDocRootId, spaceType, rootid, this.nodeType, templateList),
        );
      }
    }
    return ret;
  }

  getParentNode() {
    if (this.data.p !== null && this.data.p.length <= 32 && this.nodeManager.hasData(this.data.p)) {
      return this.nodeManager.getNode(this.data.p);
    }
    return null;
  }

  getPrevNode() {
    return this.getParentNode()?.children?.[this.index - 1] || null;
  }

  getNextNode() {
    return this.getParentNode()?.children?.[this.index + 1] || null;
  }

  /*
   *  get a flat array of nodes for search purpose,
   *  each item contains only searchable data fields
   *  mode = 0  all 灵感 & 行动
   *  mode = 1  only 灵感
   *  mode = 2  only 行动
   *  filter 过滤掉隐藏、删除、待整理、根节点、没有子节点的节点
   * */
  getFlatNodeList(mode, filter = false) {
    let ret = [];
    if (this.data) {
      if (
        mode === 0 ||
        (mode === 1 && this.actions.length === 0) ||
        (mode === 2 && this.actions.length > 0)
      ) {
        let retData = {
          id: this.id,
          title: this.title,
          // status: this.status, status 改成三态
          status: 'normal',
          _actions: this.actions,
          isCompleted: this.isCompleted,
          _delete: this.delete,
          hide: this.isHide,
          createTime: this.createTime,
          nodeType: this.nodeType,
          _prop: this.prop,
          document: this.document,
          _document: this.document,
        };
        if (filter) {
          retData.children = this.children;
          retData.hasChild = this._hasChild;
        }
        if (this.actions.length) {
          const action = this.actions[0];
          retData.status =
            action.startTime === null ? 'normal' : action.isCompleted ? 'completed' : 'action';
        }
        ret.push(retData);
      }
      for (let i = 0; i < this.children?.length; i++) {
        ret = [...ret, ...this.children[i].getFlatNodeList(mode, filter)];
      }
      if (filter) {
        return ret.filter(
          (x) =>
            x.hasChild &&
            x.nodeType !== NODE_TYPE.CLEARING &&
            !x.hide &&
            !x._delete &&
            x.id !== this.nodeManager._rootId,
        );
      }
    }
    return ret;
  }

  /**
   * TODO 拆分单个方法文件 worker也直接用
   *
   * 获取所有children的筛选条件 筛选组 排序条件
   * 1. 系统字段: 创建人，创建时间，修改时间
   * 2. 模板
   * 3. 模板属性
   * 4. 模板状态
   * 5. 模板状态属性
   */
  // 过滤条件 1. 系统字段：创建人,创建时间,修改时间 2. 模板 3. 模板属性 4. 模板状态 5. 模板状态属性
  // 排序 1. 系统字段里的时间 创建/修改 2. 模板属性的时间类型 3. 模板状态属性的时间类型
  // 分组 1. 模板属性、模板状态属性 里的枚举属性/单选人员 2. 状态
  getFilterOptionWithGroup(templateList, orgInfo) {
    return getViewSettingOptionWithGroup(templateList, orgInfo);
  }

  /**
   * ！！！ 弃用 改成worker获取
   *
   * 根据条件查询节点列表
   * @param templateList
   * @param {con:{key:string,value:any}[]} conditions
   * @param orderByKey
   * @param groupByKey
   * @param spaceUsers
   * @param orderDesc 是否降序
   * @param searchTitle 搜索标题
   * @param parentId 搜索范围
   * @param currentUser 当前用户信息
   * @param groups 空间分组列表
   */
  getNodeListByCondition(
    templateList,
    conditions,
    orderByKey = '',
    groupByKey = '',
    spaceUsers = [],
    orderDesc = true,
    searchTitle = '',
    parentId = [],
    currentUser,
    groups = [],
    noLimitTemplateDetail,
    existTreeLevelId,
  ) {
    const { allTemplates } = noLimitTemplateDetail;
    const tempMap = templateList.reduce((pre, cur) => {
      pre[cur.template_id] = cur;
      return pre;
    }, {});

    let res = [];
    const spaceUserMap = spaceUsers.reduce((a, b) => {
      a[b.account_id] = b;
      return a;
    }, {});
    const viewConditions = JSON.parse(JSON.stringify(conditions));
    viewConditions.map((c) => {
      if (c?.type === 'date' || c?.type === 'datetime') {
        if (!Array.isArray(c.value)) c.value = c.value ? [c.value] : [];
        // 自动更新的value 一定是 时分秒
        if (c.value.length === 3) {
          c.value = [dayjs().subtract(c.value[2], 'day'), dayjs()];
        }
        // 把index0 转成 start day
        // 把index1 转成 end day
        // 改成 按单位来startOf endOf
        let dateFormat = 'YYYYMMDD';
        if (c.key.startsWith('templateProp_')) {
          let [mark, templateId, propIndex] = c.key.split('_');
          const prop = tempMap[templateId]?.prop[Number(propIndex)];
          const originProp = getQuoteOriginPropInfo(prop, tempMap);
          dateFormat = originProp.dateFormat;
        }
        const config =
          Date_Format_Options.find((x) => x.value === dateFormat) || Date_Format_Options[0];
        c.value = c.value.map((x, i) => {
          if (i === 0) {
            // return dayjs(dayjs(x).format('YYYY-MM-DD')).valueOf();
            return dayjs(x).startOf(config.dayjsStartOf).valueOf();
          } else if (i === 1) {
            return dayjs(x).endOf(config.dayjsEndOf).valueOf();
            // return dayjs(dayjs(x).format('YYYY-MM-DD').concat(' 23:59:59')).valueOf();
          }
        });
        // 补齐
        while (c.value.length < 2) {
          c.value.push(null);
        }
      }
    });

    let currentAccount = null;

    function checkUserMatch(value, nodeValue) {
      const conditionValue = Array.isArray(value) ? [...value] : [value];
      if (conditionValue.includes(currentAccount) && !conditionValue.includes(currentUser.userid))
        conditionValue.push(currentUser.userid);
      if (conditionValue.includes('5F87B6C22D9E11EC8C496C92BF5C7582'))
        conditionValue.push('C58AEE14FDF411EC8C496C92BF5C7582');
      const userAndGroup = Array.isArray(nodeValue) ? [...nodeValue] : [nodeValue];
      const users = [...userAndGroup];
      users.map((userid) => {
        const user = spaceUserMap[userid];
        if (user && Array.isArray(user.group_ids)) {
          user.group_ids.map((g) => {
            if (!userAndGroup.includes(g)) userAndGroup.push(g);
          });
        }
      });
      return !!~userAndGroup.findIndex((x) => conditionValue.includes(x));
    }

    function deep(arr, inFilterRange = false) {
      arr.map((node) => {
        if (inFilterRange) {
          let isMatch = true;
          if (node.delete || node.isHide) return;
          if (searchTitle) {
            if (searchTitle.split(' ').length > 1) {
              searchTitle.split(' ').some((key) => {
                isMatch = node.title && ~node.title.toLowerCase().indexOf(key.toLowerCase());
                return !isMatch;
              });
            } else if (
              !node.title ||
              !~node.title.toLowerCase().indexOf(searchTitle.toLowerCase())
            ) {
              isMatch = false;
            }
          }
          if (isMatch) {
            viewConditions.some((con) => {
              if (propIsNull(con?.value)) {
                return false;
              }
              // 模板
              if (con.key === 'templateId') {
                if (con.value !== node.tempInfo.id) {
                  isMatch = false;
                  return true;
                }
              }
              // 负责人或参与者
              if (con.key === 'templateStatusOwnerAndParticipant') {
                let all;
                let joiner = node.tempInfo.statusProp[1] || [];
                let owner = node.tempInfo.statusProp[0];
                joiner = Array.isArray(joiner) ? joiner : [joiner];
                all = joiner.includes(owner) || !owner ? joiner : [...joiner, owner];
                if (
                  (con.value === FILTER_UNSET ||
                    (Array.isArray(con.value) && con.value.includes(FILTER_UNSET))) &&
                  !all.length
                ) {
                  isMatch = false;
                  return true;
                }
                isMatch = checkUserMatch(con.value, all);
                return !isMatch;
              }
              // 系统属性
              if (con.key === '_sys_creator') {
                isMatch = !node.creator ? false : checkUserMatch(con.value, node.creator);
                return !isMatch;
              }
              if (con.key === '_sys_createTime') {
                isMatch = isBetween(node.prop._sys_createTime * 1000, con.value);
                if (!isMatch) return true;
              }
              if (con.key === '_sys_tag') {
                if (Array.isArray(con.value) && con.value.length) {
                  if (
                    !node.prop._sys_tag ||
                    typeof node.prop._sys_tag !== 'object' ||
                    !Object.keys(node.prop._sys_tag).length
                  ) {
                    isMatch = !!~con.value.indexOf(FILTER_UNSET);
                  } else if (
                    !Object.keys(node.prop._sys_tag).find((tag) => ~con.value.indexOf(tag))
                  ) {
                    isMatch = false;
                  }
                  if (!isMatch) return true;
                }
              }
              // 模板状态
              if (con.key === 'templateStatus') {
                if (!Array.isArray(con.value)) {
                  con.value = [con.value];
                }

                if (allTemplates) {
                  // 不限主题的多状态的筛选逻辑
                  const tempIdMap = {};

                  con.value.forEach((i) => {
                    const [tempId, statusIndex] = i.split('_');
                    if (tempIdMap[tempId]) tempIdMap[tempId].push(Number(statusIndex));
                    else tempIdMap[tempId] = [Number(statusIndex)];
                  });

                  if (
                    tempIdMap[node.tempInfo.id] &&
                    !tempIdMap[node.tempInfo.id].includes(node.tempInfo.status)
                  ) {
                    isMatch = false;
                    return true;
                  }
                } else {
                  const templateId = con.value[0].split('_')[0];
                  const statusKeys = con.value.map((value) => Number(value.split('_')[1]));
                  if (
                    node.tempInfo.id !== templateId ||
                    !~statusKeys.indexOf(node.tempInfo.status)
                  ) {
                    isMatch = false;
                    return true;
                  }
                }
              }
              // 模板状态属性
              // base 基础属性 [负责人,参与者,开始时间,结束时间]
              if (con.key.startsWith('templateStatusPropBase_')) {
                let [mark, propIndex] = con.key.split('_');
                propIndex = Number(propIndex);
                if (propIsNull(node.tempInfo.statusProp[propIndex])) {
                  isMatch =
                    con.value === FILTER_UNSET ||
                    (Array.isArray(con.value) && con.value.includes(FILTER_UNSET));
                  return !isMatch;
                }
                if (con.type === 'date' || con.type === 'datetime') {
                  isMatch = isBetween(node.tempInfo.statusProp[propIndex], con.value);
                } else if (con.type === 'enum') {
                  if (!Array.isArray(con.value)) {
                    con.value = [con.value];
                  }
                  if (Array.isArray(node.tempInfo.statusProp[propIndex])) {
                    if (
                      !~node.tempInfo.statusProp[propIndex].findIndex((x) => ~con.value.indexOf(x))
                    ) {
                      isMatch = false;
                    }
                  } else if (!~con.value.indexOf(node.tempInfo.statusProp[propIndex])) {
                    isMatch = false;
                  }
                } else if (con.type === 'user') {
                  isMatch = checkUserMatch(con.value, node.tempInfo.statusProp[propIndex]);
                } else if (con.type === 'text') {
                  isMatch = !!con.value?.find(
                    (x) => x?.toString() === node.tempInfo.statusProp?.[propIndex],
                  );
                } else {
                  if (node.tempInfo.statusProp[propIndex] !== con.value) {
                    isMatch = false;
                  }
                }

                return !isMatch;
              }
              // 模板属性
              if (con.key.startsWith('templateProp_')) {
                let [mark, templateId, propIndex] = con.key.split('_');
                propIndex = Number(propIndex);
                const propValue = node.tempInfo.prop[propIndex];
                if (node.tempInfo.id !== templateId) {
                  isMatch = false;
                  return true;
                }
                // 如果节点的值是 propIsNull
                // 选项里有 未定义 才算匹配
                // 20230227 数字不走这个逻辑 引用属性没定义 不希望被隐藏
                // 20230228 日期也不走这个逻辑

                // /**
                //  *
                //  * ~~20230815 根据柳青的判断，如果属性值为空，也不需要被过滤~~
                //  *
                //  * ~~conditionV2 处理结果需要和 ff 确认~~
                //  */
                if (
                  propIsNull(node.tempInfo.prop[propIndex]) &&
                  con.type !== 'number' &&
                  con.type !== 'date'
                ) {
                  isMatch =
                    con.value === FILTER_UNSET ||
                    (Array.isArray(con.value) && con.value.includes(FILTER_UNSET));
                  return !isMatch;
                }

                if (con.type === 'date' || con.type === 'datetime') {
                  isMatch = isBetween(node.tempInfo.prop[propIndex], con.value);
                } else if (con.type === 'number') {
                  isMatch = filterNumber(node.tempInfo.prop[propIndex], con.value);
                } else if (con.type === 'user') {
                  isMatch = checkUserMatch(con.value, node.tempInfo.prop[propIndex]);
                } else if (con.type === 'cascade') {
                  if (Array.isArray(propValue) && propValue.length) {
                    /// op等于 节点数据里 包含 筛选条件的每一项
                    let _isMatch = true;
                    con.value.map((x) => {
                      if (!propValue.includes(x)) {
                        _isMatch = false;
                      }
                    });
                    isMatch = _isMatch;

                    // isMatch =
                    //   propIsNull(con.value) ||
                    //   !!~node.tempInfo.prop[propIndex].findIndex((x) => {
                    //     if (typeof x === 'string')
                    //       return !!~con.value.findIndex((v) => v.includes(x));
                    //     return !!~x.findIndex((y) => !!~con.value.findIndex((v) => v.includes(y)));
                    //   });
                  } else {
                    isMatch = propIsNull(con.value);
                  }
                } else if (con.type === 'text' || con.type === 'str') {
                  const v = takeOne(con.value);
                  if (!v) isMatch = true;
                  else isMatch = !!~(String(node.tempInfo.prop[propIndex]) || '').indexOf(v);
                } else {
                  if (Array.isArray(node.tempInfo.prop[propIndex])) {
                    // 多选
                    if (Array.isArray(con.value)) {
                      isMatch =
                        !con.value.length ||
                        !!~node.tempInfo.prop[propIndex].findIndex(
                          (x) => !!~con.value.indexOf(x?.toString()),
                        );
                    } else {
                      isMatch = !!~node.tempInfo.prop[propIndex].findIndex(
                        (x) => x?.toString() === con.value,
                      );
                    }
                  } else {
                    if (Array.isArray(con.value)) {
                      isMatch =
                        !con.value.length ||
                        con.value.includes(node.tempInfo.prop[propIndex]?.toString());
                    } else {
                      isMatch = con.value === node.tempInfo.prop[propIndex]?.toString();
                    }
                  }
                }
                return !isMatch;
              }
            });
          }
          // is match
          if (isMatch) {
            res.push(node);
          }
        }
        // deep children
        if (node.hasChild) {
          deep(node.children, inFilterRange || !!~parentId.indexOf(node.id));
        }
      });
    }

    deep(this.children, !!~parentId.indexOf(this.id));
    if (allTemplates)
      res = res.filter((n) => {
        const v = n.template && n.tempInfo.id && n.tempInfo.id.toLocaleUpperCase() !== 'FF';
        if (!v) return false;
        if (allTemplates.length === 0) return true;
        return allTemplates.includes(n.tempInfo.id);
      });

    // 排序 orderByKey
    // 主题树顺序
    if (orderByKey === 'treeLevel' && existTreeLevelId) {
      if (res.length) {
        const node = res[0];
        const treeLevelMap = node.nodeManager.getNodeTreeSerialNumber(res);
        res.forEach((n) => {
          n.treeLevelId = treeLevelMap[n.id];
        });
      } else res = [];
    }
    // 更新时间排序
    if (orderByKey === '_sys_updateTime') {
      res.sort((nodeA, nodeB) => nodeB.metadata.m - nodeA.metadata.m);
    }
    // 系统属性
    if (orderByKey === '_sys_createTime') {
      res = res.sort((nodeA, nodeB) => {
        return orderDesc
          ? nodeB.prop[orderByKey] - nodeA.prop[orderByKey]
          : nodeA.prop[orderByKey] - nodeB.prop[orderByKey];
      });
    }
    if (orderByKey === 'templateStatus' && !!conditions.find((con) => con.key === 'templateId')) {
      res = res.sort((nodeA, nodeB) => {
        return orderDesc
          ? nodeB.tempInfo.status - nodeA.tempInfo.status
          : nodeA.tempInfo.status - nodeB.tempInfo.status;
      });
    }
    if (orderByKey.startsWith('templateProp_')) {
      let [mark, templateId, propIndex] = orderByKey.split('_');
      propIndex = Number(propIndex);

      // 主题类型存在属性值的节点
      const hasAttrValueNodes = [];
      const restNodes = [];

      res.forEach((node) => {
        const prop = node.tempInfo?.prop || [];

        if (prop.length === 0 || prop[propIndex] === null) {
          restNodes.push(node);
        } else {
          hasAttrValueNodes.push(node);
        }
      });

      res = hasAttrValueNodes.sort((nodeA, nodeB) => {
        const v1 = nodeA.tempInfo.prop[propIndex];
        const v2 = nodeB.tempInfo.prop[propIndex];
        return orderDesc ? Number(v2) - Number(v1) : Number(v1) - Number(v2);
      });

      res.push(...restNodes);
    }
    if (orderByKey.startsWith('templateStatusPropBase_')) {
      let [mark, propIndex] = orderByKey.split('_');
      propIndex = Number(propIndex);
      if (propIndex === 2 || propIndex === 3) {
        //目前只支持时间排序
        res = res.sort((nodeA, nodeB) => {
          const v1 = !!nodeA.tempInfo.statusProp[propIndex]
            ? new Date(nodeA.tempInfo.statusProp[propIndex])
            : 0;
          const v2 = !!nodeB.tempInfo.statusProp[propIndex]
            ? new Date(nodeB.tempInfo.statusProp[propIndex])
            : 0;
          return orderDesc ? v2 - v1 : v1 - v2;
        });
      }
    }

    function genUserGroupMap(groupType) {
      let gm = {};
      if (groupType === '0') {
        spaceUsers?.map((user) => {
          gm[user.account_id] = {
            name: user.account_id,
            list: [],
            nameType: 'user',
          };
        });
      } else {
        groups?.map((g) => {
          gm[g.group_id] = {
            name: g.group_id,
            list: [],
            nameType: 'group',
          };
        });
      }
      gm['default'] = {
        name: '未定义',
        list: [],
        nameType: groupType === '0' ? 'user' : 'group',
      };
      return gm;
    }

    function genUserGroups(users) {
      return users.reduce((a, b) => {
        const user = spaceUserMap[b];
        if (Array.isArray(user?.group_ids)) {
          user.group_ids.map((g) => {
            if (!a.includes(g)) a.push(g);
          });
        }
        return a;
      }, []);
    }

    // 分组 groupByKey  1. 模板里的枚举属性/单选人员 2. 状态
    let groupMap;
    if (!groupByKey) {
      res = {
        default: { list: res, name: '', info: {} },
      };
    } else if (groupByKey === 'template') {
      groupMap = {};

      res.forEach((node) => {
        const temp_id = node.tempInfo.id;

        if (groupMap[temp_id]) {
          groupMap[temp_id].list.push(node);
        } else {
          groupMap[temp_id] = {
            name: temp_id,
            list: [node],
            nameType: 'template',
          };
        }
      });
    } else if (groupByKey === 'dayHours') {
      groupMap = {};

      res.forEach((node) => {
        const startTime = node.tempInfo.statusProp[2];
        if (!startTime) return;

        const hour = dayjs(startTime).format('HH:00');

        if (groupMap[hour]) {
          groupMap[hour].list.push(node);
        } else {
          groupMap[hour] = {
            name: hour,
            list: [node],
          };
        }
      });
    } else if (groupByKey.startsWith('templateStatusOwnerAndParticipant')) {
      // 负责人或参与者
      const groupType = groupByKey.split('_')[1] || '0';
      const propType = groupType === '0' ? 'user' : '1';
      groupMap = genUserGroupMap(groupType);
      res.map((node) => {
        let all;
        let joiner = node.tempInfo.statusProp[1] || [];
        let owner = node.tempInfo.statusProp[0];
        joiner = Array.isArray(joiner) ? joiner : [joiner];
        all = joiner.includes(owner) || !owner ? joiner : [...joiner, owner];
        if (groupType !== '0') {
          all = genUserGroups(all);
        }
        if (Array.isArray(all) && all.length) {
          all.forEach((x) => {
            if (groupMap[x]) {
              groupMap[x].list.push(node);
            } else if (x) {
              groupMap[x] = {
                name: x,
                list: [node],
                nameType: propType,
              };
            }
          });
        } else {
          if (groupMap['default']) {
            groupMap['default'].list.push(node);
          } else {
            groupMap['default'] = {
              name: 'default',
              list: [node],
              nameType: propType,
            };
          }
        }
      });
    } else if (groupByKey === 'templateStatus') {
      //状态
      groupMap = {
        default: {
          name: '未定义',
          list: [],
          sort: -1,
        },
      };
      const tempId = conditions.find((con) => con.key === 'templateId')?.value;
      const tempData = templateList?.find((x) => x.template_id === tempId);
      if (Array.isArray(tempData?.task_status)) {
        tempData.task_status.forEach((task, taskIndex) => {
          if (!task?.name || task.delete) return;
          const key = `${tempId}_${taskIndex}`;
          groupMap[key] = {
            name: task.name,
            list: [],
            info: {
              tempId: tempId,
              status: taskIndex,
            },
            sort: task.sort ?? taskIndex,
          };
        });
      }
      res.map((node) => {
        let key = `${node.tempInfo.id}_${node.tempInfo.status}`;
        if (!groupMap[key]) {
          groupMap['default'].list.push(node);
        } else {
          groupMap[key].list.push(node);
        }
      });
    } else if (groupByKey === 'sysCreator') {
      const propType = 'user';
      groupMap = genUserGroupMap('0');
      res.map((node) => {
        let key = node.creator;
        if (!key || !spaceUsers.find((x) => x.account_id === key)) {
          key = 'default';
        }
        if (groupMap[key]) {
          groupMap[key].list.push(node);
        } else {
          groupMap[key] = {
            name: key,
            list: [node],
            nameType: propType,
          };
        }
      });
    } else if (groupByKey === '_sys_tag') {
      const propType = 'tag';
      groupMap = {};
      groupMap['default'] = {
        name: '未定义',
        list: [],
        nameType: propType,
      };
      res.map((node) => {
        const tags =
          node.prop?._sys_tag && Object.keys(node.prop._sys_tag)?.length
            ? Object.keys(node.prop._sys_tag)
            : ['default'];
        tags.map((key) => {
          if (groupMap[key]) {
            groupMap[key].list.push(node);
          } else {
            groupMap[key] = {
              name: key,
              list: [node],
              nameType: propType,
            };
          }
        });
      });
    } else if (groupByKey.startsWith('templateStatusPropBase_')) {
      //状态任务属性（负责人、参与者、开始时间、结束时间）
      let [mark, statusPropIndex, type] = groupByKey.split('_');
      statusPropIndex = Number(statusPropIndex);
      if (!type) type = '0';
      // base只有4个 可分组的只有user类型
      const propType = type === '0' ? 'user' : 'group';
      groupMap = genUserGroupMap(type);

      res.forEach((node) => {
        let key = node.tempInfo.statusProp[statusPropIndex];
        if (propIsNull(key)) {
          key = ['default'];
        } else {
          if (!Array.isArray(key)) key = [key];
          if (type !== '0') {
            key = genUserGroups(key);
          }
        }
        key.forEach((x) => {
          if (groupMap[x]) {
            groupMap[x].list.push(node);
          } else {
            groupMap[x] = {
              name: x,
              list: [node],
              nameType: propType,
            };
          }
        });
      });
    } else {
      let propInfo = null,
        propIndex = null,
        propType = '0';
      groupMap = {};
      if (groupByKey.startsWith('templateProp_')) {
        //模板属性
        let [mark, tempId, index, type] = groupByKey.split('_');
        propIndex = Number(index);
        propType = type || '0';
        const tempData = templateList?.find((x) => x.template_id === tempId);
        if (tempData && tempData.prop[propIndex]) {
          propInfo = tempData.prop[propIndex];
        }
        res = res.filter((x) => x.tempInfo.id === tempId);
      }
      /* else if (groupByKey.startsWith('templateStatusPropCustom_')) {
        //状态属性
        let [mark, tempId, statusIndex, statusPropIndex] = groupByKey.split('_');
        statusIndex = Number(statusIndex);
        propIndex = Number(statusPropIndex);
        const tempData = templateList?.find((x) => x.template_id === tempId);
        if (
          tempData &&
          tempData.task_status[statusIndex] &&
          tempData.task_status[statusIndex].prop[propIndex]
        ) {
          propInfo = tempData.task_status[statusIndex].prop[propIndex];
        }
        res = res.filter((x) => x.tempInfo.id === tempId && x.tempInfo.status === statusIndex);
      }*/
      if (!propInfo) return groupMap;
      switch (propInfo.type) {
        case 'user':
          /*const users =
            !Array.isArray(propInfo.extend) ||
            propInfo.extend.length === 0 ||
            ~propInfo.extend.indexOf('-1')
              ? spaceUsers
              : spaceUsers.filter(
                  (user) =>
                    Array.isArray(user.group_ids) &&
                    !!user.group_ids.find((id) => ~propInfo.extend.indexOf(id)),
                );
          users?.map((user) => {
            groupMap[user.account_id] = {
              name: user.account_id,
              list: [],
              nameType: propInfo.type,
            };
          });*/
          groupMap = genUserGroupMap(propType);
          break;
        case 'enum':
        case 'tag':
          propInfo.extend?.map((x, i) => {
            groupMap[x] = {
              name: x,
              list: [],
              nameType: propInfo.type,
              sort: i,
            };
          });
          break;
      }
      propType = propType === '0' ? propInfo.type : 'group';
      groupMap['default'] = {
        name: '未定义',
        list: [],
        nameType: propType,
      };
      res.map((node) => {
        let key = groupByKey.startsWith('templateProp_')
          ? node.tempInfo.prop[propIndex]
          : node.tempInfo.statusProp[propIndex];
        // 数字 分组时未填写等于0
        if (propIsNull(key)) {
          key = propType === 'number' ? ['0'] : ['default'];
        }
        if (!Array.isArray(key)) key = [key];
        if (propType === 'group') key = genUserGroups(key);
        let unknowKey = false;
        key.map((x) => {
          if (groupMap[x]) {
            groupMap[x].list.push(node);
          } else if (x) {
            groupMap[x] = {
              name: x,
              list: [node],
              nameType: propType,
            };
          } else {
            unknowKey = true;
          }
        });
        if (unknowKey) {
          groupMap['default'].list.push(node);
        }
      });
    }
    if (groupMap) {
      /*if ('default' in groupMap && !groupMap['default'].list.length) {
        delete groupMap['default'];
      }*/
      Object.keys(groupMap).forEach((key) => {
        if (!groupMap[key].list.length) {
          delete groupMap[key];
        }
      });
      return groupMap;
    }
    /*if (conditions?.length && groupByKey) {
      const groupCondition = conditions.find((c) => c.key === groupByKey);
      if (groupCondition && Array.isArray(groupCondition.value) && groupCondition.value.length) {
        Object.keys(res).map((key) => {
          if (
            !~groupCondition.value.indexOf(key) &&
            !(key === 'default' && ~groupCondition.value.indexOf(FILTER_UNSET))
          ) {
            delete res[key];
          }
        });
      }
    }*/
    return res;
  }

  /**
   * 获取引用计数或引用标题 符合条件的主题
   * @param prop 当前选择的属性
   * @param propIndex 当前选择的属性索引
   * @param data 当前主题
   * @returns {*[]}
   */
  getQuoteNodes(prop, propIndex, data) {
    const res = [];
    const matchingRoot = this.nodeManager.findChildren(prop.matchingSource);
    const tempProp = data.prop?._sys_temp?.[1] || [];
    if (matchingRoot) {
      const conditionValues = prop.conditionProp.map((x) => {
        if (x < 0) {
          if (x === -1) {
            //创建人
            return data.prop._sys_creator;
          } else if (x === -3) {
            //标题
            return data.title;
          } else {
            return null;
          }
        } else {
          return typeof tempProp[x] === 'number' ? tempProp[x].toString() : tempProp[x];
        }
      });
      const propData = tempProp[propIndex];
      const quoteProps = prop.quoteProp.map((x) => Number(x.split('-')[1]));
      if (
        quoteProps.length !== conditionValues.length ||
        ~quoteProps.findIndex((x) => !Number.isFinite(x))
      )
        return res;

      const deep = (nodeArr) => {
        nodeArr.map((n) => {
          if (!(n.metadata.f >= 0 && n.metadata.f !== 2)) return; // 已删除,草稿箱
          if (n.tempInfo.id === prop.matchingTemplate) {
            let isMatch = true;
            // 非引用计数且引用标题
            if (prop.matchingType !== 5 && ~prop.matchingProp.indexOf('-3')) {
              // 多选情况
              const multipleMatch = Array.isArray(propData) && propData.includes(n.title);
              isMatch =
                n.title === propData ||
                multipleMatch ||
                (Array.isArray(propData) && propData.length === 1 && propData[0] === n.title);
            }
            if (isMatch) {
              quoteProps.some((index, i) => {
                const key = n.tempInfo.prop[index];
                if (key === conditionValues[i]) return false;
                // 引用属性使用部分匹配的逻辑
                if (prop.type === 'quote') {
                  if (Array.isArray(key)) {
                    if (Array.isArray(conditionValues[i])) {
                      if (conditionValues[i].find((z) => key.includes(z))) return false;
                    } else {
                      if (key.includes(conditionValues[i])) return false;
                    }
                  } else if (
                    Array.isArray(conditionValues[i]) &&
                    conditionValues[i].includes(key)
                  ) {
                    return false;
                  }
                } else {
                  if (Array.isArray(key)) {
                    if (Array.isArray(conditionValues[i])) {
                      if (!conditionValues[i].find((z) => !key.includes(z))) return false;
                    } else {
                      if (key.includes(conditionValues[i])) return false;
                    }
                  } else if (
                    Array.isArray(conditionValues[i]) &&
                    conditionValues[i].length === 1 &&
                    conditionValues[i][0] === key
                  ) {
                    return false;
                  }
                }
                isMatch = false;
                return true;
              });
            }
            if (isMatch) res.push(n);
          }
          if (n.hasChild) {
            deep(n.children);
          }
        });
      };
      deep(matchingRoot.children);
    }
    return res;
  }

  getActionProgress() {
    let completed = 0;
    let total = 0;
    if (this.actions && this.actions.length > 0 && !this.delete && !this.isHide) {
      //current node is an action
      total++;
      if (this.actions[0].isCompleted) {
        completed++;
      }
    }
    const children = this.children;
    for (let i = 0; i < children.length; i++) {
      let childrenProgress = children[i].getActionProgress();
      completed = completed + childrenProgress.completed;
      total = total + childrenProgress.total;
    }
    return { completed, total };
  }

  // 根据条件筛选node
  tarverseNodeByCondition(conditions = [], callback, isDeep = true) {
    // TODO 条件需要重新确认
    let matching = true;

    if (conditions.length) {
      conditions.map((con) => {
        if (this[con.field] !== con.value) {
          matching = false;
        }
      });
      if (matching) {
        callback(this);
      }
    } else {
      callback(this);
    }
    const children = this.children;
    if (isDeep || !matching) {
      for (let i = 0; i < children?.length; i++) {
        children[i].tarverseNodeByCondition(conditions, callback, isDeep);
      }
    }
  }

  /**
   * 获取在节点下 新增节点的默认主题类型
   * 获取方式：从自身往上层取
   * 空间根节点的默认主题类型 拿接口里的
   */
  getDefaultAddTempId(templateMap = {}, orgDefaultAddTempIdByApi = 'ff') {
    // 主题类型被删除
    const nowTemplate = templateMap[orgDefaultAddTempIdByApi];
    // 没被删除的主题类型
    const notDelTemplates = Object.values(templateMap).filter((t) => t.status !== 3);
    if (notDelTemplates.length === 0) orgDefaultAddTempIdByApi = 'ff';
    else {
      if (!nowTemplate || nowTemplate.status === 3)
        orgDefaultAddTempIdByApi = notDelTemplates[0].template_id;
    }
    //-----------------

    const isRoot = this.node_id === this.nodeManager._rootId;
    if (isRoot) {
      return orgDefaultAddTempIdByApi;
    }
    const id = this.prop._sys_defaultAddTempId;
    if (id && templateMap[id]) {
      return id;
    } else {
      if (this.parent) {
        return this.parent.getDefaultAddTempId(templateMap, orgDefaultAddTempIdByApi);
      }
      return orgDefaultAddTempIdByApi;
    }
  }
}

const NetWorkError = Symbol('NetWorkError');

class retryNetwork {
  constructor(network, retry = 3) {
    this._network = network;
    this._retry = retry;
  }

  async call(url, op) {
    let retry = this._retry;
    let success = false;
    let ret = NetWorkError;
    while (retry > 0) {
      try {
        ret = await this._network(url, op);
        success = true;
        break;
      } catch (e) {
        console.error(e);
      }
      retry--;
    }
    return ret;
  }
}

class NodeManager {
  constructor(
    network,
    org_id,
    accountId,
    groupIdList,
    role,
    rootId = null,
    toBeSortId = null,
    client = ClientList.web,
    loadByLayer = false,
    templateList = [],
    allUser = [],
    dataType = 3,
    orgOption = null,
    userList = [],
  ) {
    console.log('new nodemanager', org_id);
    console.log(`dataType=${dataType}, role=${role}`);
    // 初始化
    this._waitInit = new Promise((resolve) => {
      this._InitResolve = resolve;
    });
    this._dataType = dataType;
    this._network = new retryNetwork(network); // 网络
    this._org_id = org_id;
    this._org_id_lower = org_id.toLowerCase();
    this._deletePid = this._org_id_lower + 'dd';
    this._accountId = accountId;
    this._groupIdList = groupIdList;
    this._role = role;
    this._rootId = rootId;
    this._toBeSortId = toBeSortId;
    this._defaultListen = {
      change: [],
    }; // 事件监听
    this._listen = { ...this._defaultListen };
    this._versionList = null; // 当前版本号
    this._subscriberField = {}; // 当前订阅的区域(已废弃)
    this._loadedField = {}; // 已完全载入的区域(已废弃)
    this._childrenCache = {}; // 子节点缓存
    this._indexCache = {}; // index缓存
    this._data = {}; // 节点数据, 节点为key，value是原始数据
    this._rawRoot = null; // 根节点原始数据
    this._rawParent = {}; // 节点原始父
    this._localData = {}; // 本地节点数据, 节点为key，value是原始数据
    this._wildNode = {}; // 野节点列表
    this._client = org_id.toUpperCase() === '3A0328AC0FA311EB9A4A7CD30AB8A430' ? '' : client; // 客户端类型，用于判断针对指定客户端的隐藏节点
    this._loadByLayer = typeof loadByLayer === 'boolean' ? (loadByLayer ? 1 : 0) : loadByLayer; // 分层加载开启级别 0:不开启 1:分区加载 2:首层分层加载
    this._template = {}; // 模板信息
    this.setTemplate(templateList); // 模板信息
    this._nodeFilterList = {}; // 过滤器节点缓存
    this._filterConfigMd5 = {}; //  过滤器节点的配置摘要
    this._allUser = {}; // 用户信息
    const existUser = new Set();
    for (const n of allUser) {
      if (n.org_id === org_id) {
        if (n.org_nick_name && !existUser.has(n.org_nick_name)) {
          existUser.add(n.org_nick_name);
          this._allUser[n.account_id] = n.org_nick_name;
        } else if (!existUser.has(n.nick_name)) {
          existUser.add(n.nick_name);
          this._allUser[n.account_id] = n.nick_name;
        } else if (n.org_nick_name && !existUser.has(`${n.org_nick_name}（${n.nick_name}）`)) {
          existUser.add(`${n.org_nick_name}（${n.nick_name}）`);
          this._allUser[n.account_id] = `${n.org_nick_name}（${n.nick_name}）`;
        } else {
          existUser.add(`${n.org_nick_name}（${n.account_id.slice(0, 4)}）`);
          this._allUser[n.account_id] = `${n.org_nick_name}（${n.account_id.slice(0, 4)}）`;
        }
        break;
      }
    }
    this._groupMap = {}; // 用户分组信息
    for (const n of userList) {
      this._groupMap[n.account_id] = n.group_ids;
    }
    this._parentIndex = {}; // 父节点索引， key是父节点，value是所有儿子
    this._localParentIndex = {}; // 本地数据父节点索引
    this._subscriberNode = {}; // 节点订阅
    this._subscriberTemp = {}; // 节点主题类型
    this._localOpWait = 0; // 当前正在执行的本地Op个数
    this._localOp = []; // 当前队列中的Op
    this._waitUpdate = null; // 被阻塞的本地Op阻塞的更新
    this._waitRecycle = false; // 被阻塞的getRecycle
    this._waitExpand = []; // 被阻塞的expand
    this._waitExpandTo = []; // 被阻塞的expandTo
    this._waitExpandAll = false; // 被阻塞的expandAll
    this._uploadOpRunning = false; // uploadOp运行中
    this._filterMap = {}; // 模板和过滤器节点的映射关系
    this._nodeFilterMap = {}; // 节点和过滤器节点的映射关系
    this._reSortTask = []; // reSort任务
    this._uploadOpDelay = 50; // 上传延迟,单位毫秒
    this._expandAll = false; // 是否已经expandAll
    this._node = {};
    this._initDone = {};
    this._selfReg = eval(`/${FILTER_SELF_ID}/g`);
    this._orgOption = orgOption || {};
    this._sec_node_count = 0;
  }

  get data_size() {
    return Object.keys(this._data).length + Object.keys(this._localData).length;
  }

  setTemplate(templateList) {
    templateList.forEach((n) => {
      this._template[n.template_id] = n;
    });
  }

  getNode(node_id) {
    if (node_id in this._node) return this._node[node_id];
    if (node_id.includes('_')) {
      const id = node_id.slice(node_id.indexOf('_') + 1);
      if (!(id in this._node)) {
        this._node[id] = new PiNode(this, id);
      }
      this._node[node_id] = this._node[id];
    } else {
      if (!(node_id in this._node)) {
        this._node[node_id] = new PiNode(this, node_id);
      }
    }
    return this._node[node_id];
  }

  encodeNodeId(id) {
    return id.replace(/-/g, '--').replace(/\//g, '-g').replace(/ /g, '-0').replace(/_/g, '-u');
  }

  decodeNodeId(id) {
    return id
      .replace(/--/g, 'p504dG0eL')
      .replace(/-u/g, '_')
      .replace(/-0/g, ' ')
      .replace(/-g/g, '/')
      .replace(/p504dG0eL/g, '-');
  }

  mergeBatchOp(ops) {
    if (ops.length < 2) return ops;
    const ret = [];
    let i = 0;
    const skip = new Set();
    while (i < ops.length) {
      if (skip.has(i)) {
        i++;
      } else if (ops[i][0] !== ops[i + 1]?.[0]) {
        // 不能合并
        ret.push(ops[i]);
        i++;
      } else {
        const newOp = ops[i][1];
        const op = ops[i][0];
        switch (op) {
          case '/docapi/node/insert':
            if (!Array.isArray(newOp.node)) newOp.node = [newOp.node];
            for (++i; i < ops.length; i++) {
              if (skip.has(i)) continue;
              if (
                ops[i][1].parentId === newOp.parentId &&
                ops[i][1].siblingId === newOp.node[newOp.node.length - 1].node_id
              ) {
                if (Array.isArray(ops[i][1].node)) {
                  newOp.node.push.apply(newOp, ops[i][1].node);
                } else {
                  newOp.node.push(ops[i][1].node);
                }
              } else {
                break;
              }
            }
            break;
          case '/docapi/moveToRecycle':
            if (!Array.isArray(newOp.node_id)) newOp.node_id = [newOp.node_id];
            for (++i; i < ops.length; i++) {
              if (skip.has(i)) continue;
              if (ops[i][1].org_id === newOp.org_id) {
                if (Array.isArray(ops[i][1].node_id)) {
                  newOp.node_id.push.apply(newOp, ops[i][1].node_id);
                } else {
                  newOp.node_id.push(ops[i][1].node_id);
                }
              } else {
                break;
              }
            }
            break;
          case '/docapi/node/modify':
            if (!Array.isArray(newOp.node)) newOp.node = [newOp.node];
            for (let j = i + 1; j < ops.length; j++) {
              if (op !== ops[j][0] || ops[j][1].org_id !== newOp.org_id) {
                continue;
              }
              skip.add(j);
              const node = Array.isArray(ops[j][1].node) ? ops[j][1].node : [ops[j][1].node];
              console.log(node);
              for (let k = 0; k < node.length; k++) {
                const d = newOp.node.find((n) => n.node_id === node[k].node_id);
                console.log(d);
                if (d) {
                  Object.assign(d, node[k]);
                } else {
                  newOp.node.push(node[k]);
                }
              }
            }
            i++;
            break;
          default:
            // 暂不支持合并的接口
            i++;
        }
        ret.push([op, newOp]);
      }
    }
    return ret;
  }

  async uploadOp(first = false) {
    if (this._uploadOpRunning) return;
    this._uploadOpRunning = true;
    try {
      while (this._localOpWait > 0) {
        if (this._localOp.length === 0) {
          this._uploadOpRunning = false;
          if (first) setTimeout(this.uploadOp.bind(this), 200);
          return;
        }
        const localOp = [...this._localOp];
        let ret;
        if (localOp.length > 1) {
          const mergedOp = this.mergeBatchOp(localOp);
          ret = await this._network.call('/docapi/batchOp', {
            method: 'POST',
            data: { org_id: this._org_id, ops: mergedOp },
          });
        } else {
          ret = await this._network.call(localOp[0][0], {
            method: 'POST',
            data: localOp[0][1],
          });
        }
        if (ret === NetWorkError) {
          // 如果执行失败，则过一段时间再执行
          this._uploadOpRunning = false;
          setTimeout(this.uploadOp.bind(this), 200);
          return;
        } else {
          this._localOpWait -= localOp.length;
          this._localOp = this._localOp.slice(localOp.length);
        }
      }
      if (this._waitUpdate !== null) {
        const waitUpdate = this._waitUpdate;
        this._waitUpdate = null;
        await this.parseFromJsonDoc(waitUpdate);
      }
      if (this._waitRecycle) {
        this._waitRecycle = false;
        await this.getRecycle();
      }
      if (this._waitExpandAll) {
        this._waitExpandAll = false;
        await this.expandAll();
      }
      if (this._waitExpand.length > 0) {
        const waitExpand = this._waitExpand;
        this._waitExpand = [];
        for (let i = 0; i < waitExpand.length; i++) {
          await this.expand(...waitExpand[i]);
        }
      }
      if (this._waitExpandTo.length > 0) {
        const waitExpandTo = this._waitExpandTo;
        this._waitExpandTo = [];
        for (let i = 0; i < waitExpandTo.length; i++) {
          await this.expandTo(...waitExpandTo[i]);
        }
      }
      while (true) {
        const node_id = this._reSortTask.shift();
        if (node_id) {
          await this._network.call('/docapi/reSortNode', {
            method: 'POST',
            data: { org_id: this._org_id, node_id: node_id },
          });
        } else {
          break;
        }
      }
      this._uploadOpRunning = false;
    } catch (e) {
      this._uploadOpRunning = false;
      console.error(e);
    }
    if (first) setTimeout(this.uploadOp.bind(this), 1000);
  }

  addOp(fc, parm) {
    this._localOp.push([fc, parm]);
    setTimeout(this.uploadOp.bind(this), this._uploadOpDelay, true);
  }

  insert(parentId, index, data = null, copy = null, draft = false) {
    if (parentId.indexOf('>') >= 0) throw Error(`父节点格式错误${parentId}`);
    if (!this.hasData(parentId)) throw Error(`找不到父节点${parentId}`);
    if (data !== null) {
      // console.log(data);
      this._localOpWait++;
      const now = Date.now();
      const pNode = this.getNode(parentId);
      this._localData[data.id] = {
        o: this._org_id,
        n: data.id,
        c: null,
        e: {
          ...data.prop,
          _sys_user_acl: { [this._accountId]: default_user_acl },
        },
        d: this._accountId,
        f: draft ? -2 : this.getData(parentId).f || 0,
        g: 'qd',
        h: now,
        i: this._accountId,
        j: null,
        l: pNode.data.l + 1,
        m: now,
        me: data.prop?._sys_task_status?.prop?.[3] || null,
        mg: data.prop?._sys_task_status?.prop?.[1] || [],
        ms: data.prop?._sys_task_status?.prop?.[2] || null,
        mu: data.prop?._sys_task_status?.prop?.[0] || null,
        p: null,
        q: data.prop?._sys_temp?.[0] || null,
        r: data.prop?._sys_task_status?.index || 0,
        s: null,
        t: data.title,
        v: 0,
        x: null,
      };
      if (data.content) {
        this._localData[data.id].content = data.content;
      }
      if (!draft || this.getData(parentId).f === -2) this.moveIn(data.id, parentId, index);
      const wt = this.updateFilterData([this._localData[data.id]]);
      this.updateSub({
        [data.id]: [null, { new: true, title: false, prop: false, move: false }],
      });
      this.addOp('/docapi/node/insert', {
        org_id: this._org_id,
        parentId: parentId,
        siblingId: this._localData[data.id].x,
        asyncUV: true,
        node: {
          node_id: data.id,
          prop: data.prop,
          title: data.title,
          content: data.content,
          content_type: data.content_type,
        },
        draft,
      });
      if (wt?.constructor === Promise) {
        return wt.then(() => this.getNode(data.id));
      }
      return this.getNode(data.id);
    } else if (copy !== null) {
      this.addOp('/docapi/node/insert', {
        org_id: this._org_id,
        parentId: parentId,
        siblingId: index === 0 ? null : this.getNode(parentId).children[index - 1]?.id || null,
        copyId: { ...copy },
        draft,
      });
    }
  }

  delete(nodeId, remove = false) {
    if (nodeId.indexOf('>') >= 0) throw Error(`节点ID格式错误${nodeId}`);
    if (this.hasData(nodeId)) {
      this._localOpWait++;
      const parentId = this.moveOut(nodeId);
      this.updateSub({
        [nodeId]: [parentId, { new: false, title: false, prop: false, move: true }],
      });
      this.addOp(
        remove ? '/docapi/node/remove' : '/docapi/moveToRecycle',
        remove
          ? { items: { [this._org_id]: [nodeId] } }
          : {
              org_id: this._org_id,
              node_id: nodeId,
            },
      );
    } else {
      throw Error(`找不到节点${nodeId}`);
    }
  }

  moveOut(nodeId) {
    const parentId = this.getData(nodeId).p;
    if (parentId === null || parentId.length === `${this._org_id.toLowerCase()}dd`) return;
    if (!(parentId in this._childrenCache)) {
      const pNode = this.getNode(parentId);
      pNode.children;
    }
    const pNode = this.getNode(this.getData(nodeId).p);
    const node = this.getNode(nodeId);
    const index = node.index;
    this._childrenCache[parentId].splice(index, 1);
    node.setData.x = null;
    node.setData.j = null;
    node.setData.p = `${this._org_id}DD`;
    if (index > 0 && this._childrenCache[parentId][index - 1].data.j === nodeId)
      this._childrenCache[parentId][index - 1].setData.j =
        index < this._childrenCache[parentId].length
          ? this._childrenCache[parentId][index].id
          : null;
    if (
      index < this._childrenCache[parentId].length &&
      this._childrenCache[parentId][index].data.x === nodeId
    )
      this._childrenCache[parentId][index].setData.x =
        index > 0 ? this._childrenCache[parentId][index - 1].data.id : null;
    if (pNode.data.c === nodeId)
      pNode.setData.c = this._childrenCache[parentId].length
        ? this._childrenCache[parentId][0].id
        : null;
    if (pNode.data.s === nodeId)
      pNode.setData.s = this._childrenCache[parentId].length
        ? this._childrenCache[parentId][this._childrenCache[parentId].length - 1].id
        : null;
    for (let i = index; i < this._childrenCache[parentId].length; i++) {
      this._indexCache[parentId][this._childrenCache[parentId][i].id] = i;
    }
    if (nodeId in this._indexCache[parentId]) delete this._indexCache[parentId][nodeId];
  }

  moveIn(nodeId, parentId, index) {
    const pNode = this.getNode(parentId);
    const node = this.getNode(nodeId);
    node.level = pNode.level + 1;
    if (!(parentId in this._childrenCache)) {
      pNode.children;
    }
    if (!Array.isArray(this._childrenCache[parentId])) {
      this._childrenCache[parentId] = [node];
    } else if (index < this._childrenCache[parentId].length) {
      const t = this._childrenCache[parentId].splice(
        index,
        this._childrenCache[parentId].length - index,
      );
      this._childrenCache[parentId].push(node);
      this._childrenCache[parentId].push.apply(this._childrenCache[parentId], t);
    } else {
      this._childrenCache[parentId].push(node);
    }
    node.setData.p = parentId;
    if (index > 0) {
      this._childrenCache[parentId][index - 1].setData.j = nodeId;
      node.setData.x = this._childrenCache[parentId][index - 1].id;
    } else {
      node.setData.x = null;
    }
    if (index < this._childrenCache[parentId].length - 1) {
      this._childrenCache[parentId][index + 1].setData.x = nodeId;
      node.setData.j = this._childrenCache[parentId][index + 1].id;
    } else {
      node.setData.j = null;
    }
    if (pNode.data.c === null || index === 0) pNode.setData.c = nodeId;
    if (pNode.data.s === null || index === this._childrenCache[parentId].length - 1)
      pNode.setData.s = nodeId;
    if (!(parentId in this._indexCache)) {
      this._indexCache[parentId] = {};
    }
    for (
      let i = Math.min(index, this._childrenCache[parentId].length - 1);
      i < this._childrenCache[parentId].length;
      i++
    ) {
      this._indexCache[parentId][this._childrenCache[parentId][i].id] = i;
    }
  }

  move(nodeId, newParentId, newIndex) {
    if (newParentId.indexOf('>') >= 0) throw Error(`父节点格式错误${newParentId}`);
    if (nodeId.indexOf('>') >= 0) throw Error(`节点ID格式错误${nodeId}`);
    if (this.hasData(nodeId) && this.hasData(newParentId)) {
      this._localOpWait++;
      const parentId = this.getData(nodeId).p;
      if (parentId === newParentId && this.getNode(nodeId).index < newIndex) {
        newIndex--;
      }
      this.moveOut(nodeId);
      this.moveIn(nodeId, newParentId, newIndex);
      this.updateSub({
        [nodeId]: [parentId, { new: false, title: false, prop: false, move: true }],
      });
      if (this._localData[nodeId].x === null || this._localData[nodeId].x.indexOf('>') < 0) {
        this.addOp('/docapi/node/move', {
          org_id: this._org_id,
          parentId: newParentId,
          siblingId: this._localData[nodeId].x,
          nodeId: nodeId,
        });
      } else {
        console.log(this._localData[nodeId].x);
      }
    } else {
      if (!this.hasData(nodeId)) throw Error(`找不到节点${nodeId}`);
      throw Error(`找不到父节点${newParentId}`);
    }
  }

  setTitle(nodeId, title) {
    if (!this.hasData(nodeId)) throw Error(`找不到节点${nodeId}`);
    this._localOpWait++;
    this.setData(nodeId).t = title;
    this.updateSub({
      [nodeId]: [null, { new: false, title: true, prop: false, move: false }],
    });
    this.addOp('/docapi/node/modify', {
      org_id: this._org_id,
      node: {
        node_id: nodeId,
        title,
      },
    });
  }

  updateProp(nodeId, prop) {
    if (!this.hasData(nodeId)) throw Error(`找不到节点${nodeId}`);
    const e = deepCopy(this.getData(nodeId).e);
    if (Array.isArray(this._template[e._sys_temp?.[0]]?.temp_option?.unique)) {
      const temp_id = e._sys_temp[0];
      rule_for: for (
        let rule_id = 0;
        rule_id < this._template[temp_id].temp_option.unique.length;
        rule_id++
      ) {
        const rule = this._template[temp_id].temp_option.unique[rule_id];
        if (Array.isArray(rule)) {
          let f = true;
          for (let i = 0; i < rule.length; i++) {
            // 检查当次修改的属性是否被包含在rule中
            if (prop.index.includes(rule[i])) {
              const pid = prop.index.findIndex((n) => n === rule[i]);
              if (
                prop.value[pid] !== null &&
                prop.value[pid] !== undefined &&
                (Array.isArray(prop.value[pid])
                  ? prop.value[pid].length === 1
                  : prop.value[pid]?.length !== 0)
              ) {
                f = false;
                break;
              }
            }
          }
          if (f) continue;
          const value = [];
          for (let i = 0; i < rule.length; i++) {
            let v = null;
            if (prop.index.includes(rule[i])) {
              const pid = prop.index.findIndex((n) => n === rule[i]);
              if (Array.isArray(prop.value[pid])) {
                v = prop.value[pid][0];
              } else {
                v = prop.value[pid];
              }
            } else {
              if (Array.isArray(e._sys_temp[1][rule[i]])) {
                if (e._sys_temp[1][rule[i]].length === 1) {
                  v = e._sys_temp[1][rule[i]][0];
                }
              } else {
                v = e._sys_temp[1][rule[i]];
              }
            }
            if (typeof v !== 'string') {
              if (Number.isFinite(v)) {
                if (
                  this._template[temp_id].prop[rule[i]]?.type === 'date' ||
                  this._template[temp_id].prop[rule[i]]?.type === 'datetime'
                ) {
                  const df =
                    this._template[temp_id].prop[rule[i]]?.dateFormat ||
                    (this._template[temp_id].prop[rule[i]]?.type === 'date' ? 'day' : 'min');
                  v = convertDateTime(
                    v,
                    Date_Format_Options.find((d) => d.value === df)?.formula || 'min',
                  );
                } else {
                  v = String(v);
                }
              }
            }
            if (typeof v !== 'string') {
              continue rule_for;
            }
            value.push(v);
          }
          const node_list = [];
          for (const node_id in this._localData) {
            if (this._localData[node_id].e?._sys_temp?.[0] !== temp_id) continue;
            node_list.push(this._localData[node_id]);
          }
          for (const node_id in this._data) {
            if (node_id in this._localData) continue;
            if (this._data[node_id].e?._sys_temp?.[0] !== temp_id) continue;
            node_list.push(this._data[node_id]);
          }
          const field = this.getData(nodeId).f;
          node_for: for (const node of node_list) {
            if (node.f === 2 || node.f === -1) continue;
            if (node.f === -2 && field !== -2) continue;
            const e = node.e;
            let r = 0;
            for (let i = 0; i < rule.length; i++) {
              let v = null;
              if (Array.isArray(e._sys_temp[1][rule[i]])) {
                if (e._sys_temp[1][rule[i]].length === 1) {
                  v = e._sys_temp[1][rule[i]][0];
                }
              } else {
                v = e._sys_temp[1][rule[i]];
              }
              if (typeof v !== 'string') {
                if (Number.isFinite(v)) {
                  if (
                    this._template[temp_id].prop[rule[i]]?.type === 'date' ||
                    this._template[temp_id].prop[rule[i]]?.type === 'datetime'
                  ) {
                    const df =
                      this._template[temp_id].prop[rule[i]]?.dateFormat ||
                      (this._template[temp_id].prop[rule[i]]?.type === 'date' ? 'day' : 'min');
                    v = convertDateTime(
                      v,
                      Date_Format_Options.find((d) => d.value === df)?.formula || 'min',
                    );
                  } else {
                    v = String(v);
                  }
                }
              }
              if (typeof v !== 'string') {
                continue node_for;
              }
              if (v !== value[i]) break;
              r++;
            }
            if (r === rule.length) {
              console.error('唯一属性冲突');
              throw Error('唯一属性冲突');
            }
          }
        }
      }
    }
    this._localOpWait++;
    if (!Array.isArray(e._sys_temp)) {
      e._sys_temp = [prop.temp_id, []];
    }
    if (!Array.isArray(e._sys_temp[1])) e._sys_temp[1] = [];
    for (let i = 0; i < prop.index.length; i++) {
      const index = prop.index[i];
      while (e._sys_temp[1].length <= index) e._sys_temp[1].push(null);
      e._sys_temp[1][index] = prop.value[i];
      if (prop.location && index in prop.location) {
        if (!e._sys_location) e._sys_location = {};
        e._sys_location[index] = prop.location[index];
      } else if (prop.attachment && index in prop.attachment) {
        if (!e._sys_attach) e._sys_attach = {};
        e._sys_attach[index] = prop.attachment[index];
      } else if (prop.cascade && index in prop.cascade) {
        if (!e._sys_cascade) e._sys_cascade = {};
        e._sys_cascade[index] = prop.cascade[index];
      }
    }
    this.setData(nodeId).e = e;
    this.updateSub({
      [nodeId]: [null, { new: false, title: false, prop: true, move: false }],
    });
    this.addOp('/docapi/updateProp', {
      ...prop,
      org_id: this._org_id,
      node_id: nodeId,
      asyncUV: true,
    });
  }

  setAction(nodeIdList, newProp) {
    for (let i = 0; i < nodeIdList.length; i++) {
      if (!this.hasData(nodeIdList[i])) throw Error(`找不到节点${nodeIdList[i]}`);
    }
    this._localOpWait++;
    const cleanList = [];
    const nodeMap = {};
    let nodeProp = {};
    for (let i = 0; i < nodeIdList.length; i++) {
      nodeProp[nodeIdList[i]] = newProp;
      const prop = this.setData(nodeIdList[i]).e;
      if (!Array.isArray(prop._sys_temp)) {
        prop._sys_temp = [null, []];
      }
      if (!Array.isArray(prop._sys_task_status))
        prop._sys_task_status = {
          index: 0,
          prop: [null, null, Date.now(), null],
        };
      if ('temp_id' in newProp) {
        if (typeof prop._sys_temp[0] === 'string' && prop._sys_temp[0] !== newProp.temp_id) {
          // 清理action
          cleanList.push(nodeIdList[i]);
          prop._sys_temp = [newProp.temp_id, []];
          prop._sys_task_status = {
            index: 0,
            prop: [null, [], Date.now(), null],
          };
        }
      }
      if ('status' in newProp) {
        prop._sys_task_status.index = newProp.status;
      }
      if ('startTime' in newProp) {
        prop._sys_task_status.prop[2] = newProp.startTime;
      } else if (newProp.nodeProp?.[nodeIdList[i]]?.startTime !== undefined) {
        prop._sys_task_status.prop[2] = newProp.nodeProp[nodeIdList[i]].startTime;
      }
      if ('endTime' in newProp) {
        prop._sys_task_status.prop[3] = newProp.endTime;
      } else if (newProp.nodeProp?.[nodeIdList[i]]?.endTime !== undefined) {
        prop._sys_task_status.prop[3] = newProp.nodeProp[nodeIdList[i]].endTime;
      }
      if ('owner' in newProp) {
        prop._sys_task_status.prop[0] = newProp.owner;
      } else if (newProp.nodeProp?.[nodeIdList[i]]?.owner !== undefined) {
        prop._sys_task_status.prop[0] = newProp.nodeProp[nodeIdList[i]].owner;
      }
      if ('user' in newProp) {
        prop._sys_task_status.prop[1] = newProp.user;
      } else if (newProp.nodeProp?.[nodeIdList[i]]?.user !== undefined) {
        prop._sys_task_status.prop[1] = newProp.nodeProp[nodeIdList[i]].user;
      }
      if ('statusCommit' in newProp) {
        prop._sys_task_status.prop[4] = newProp.statusCommit;
      } else if (newProp.nodeProp?.[nodeIdList[i]]?.statusCommit !== undefined) {
        prop._sys_task_status.prop[4] = newProp.nodeProp[nodeIdList[i]].statusCommit;
      }
      if ('temp_prop' in newProp) {
        prop._sys_temp[1] = newProp.temp_prop;
      } else if (newProp.nodeProp?.[nodeIdList[i]]?.temp_prop !== undefined) {
        prop._sys_temp[1] = newProp.nodeProp[nodeIdList[i]].temp_prop;
      }
      nodeMap[nodeIdList[i]] = [null, { new: false, title: false, prop: true, move: false }];
    }
    this.updateSub(nodeMap);
    if (cleanList.length) {
      this.addOp('/docapi/clearAction', {
        org_id: this._org_id,
        node: cleanList,
      });
    }
    this.addOp('/docapi/setAction', {
      ...newProp,
      org_id: this._org_id,
      node: nodeIdList,
      nodeProp,
    });
  }

  getData(node_id) {
    return this._localData[node_id] || this._data[node_id];
  }

  setData(node_id) {
    if (!(node_id in this._localData) && node_id in this._data) {
      this._localData[node_id] = JSON.parse(JSON.stringify(this._data[node_id]));
    }
    this._localData[node_id].v = this._v;
    return this._localData[node_id];
  }

  hasData(node_id) {
    return node_id in this._data || node_id in this._localData;
  }

  getParentIndex(node_id) {
    if (!(node_id in this._localParentIndex)) {
      return this._parentIndex[node_id];
    } else if (!(node_id in this._parentIndex)) {
      return this._localParentIndex[node_id];
    } else {
      return {
        ...this._parentIndex[node_id],
        ...this._localParentIndex[node_id],
      };
    }
  }

  hasParentIndex(node_id) {
    return (
      objectHasKey(this._parentIndex[node_id]) || objectHasKey(this._localParentIndex[node_id])
    );
  }

  listen(eventName, cb) {
    this._listen[eventName].push(cb);
  }

  unListen(eventName, cb = null) {
    if (cb === null) {
      this._listen[eventName] = [];
    } else {
      for (let i = 0; i < this._listen[eventName].length; i++) {
        if (this._listen[eventName][i] === cb) {
          this._listen[eventName].splice(i, 1);
          break;
        }
      }
    }
  }

  destroyListen(eventName = null) {
    if (eventName === null) {
      this._listen = { ...this._defaultListen };
    } else {
      this._listen[eventName] = [];
    }
  }

  // 清理数据
  destroyData(retainNode = []) {
    if (retainNode.length === 0) {
      this._data = [];
      this._parentIndex = {};
    } else {
      const retain = {};
      const newParentIndex = {};
      for (let i = 0; i < retainNode.length; i++) {
        retain[retainNode[i]] = true;
        if (retainNode[i] in this._parentIndex)
          newParentIndex[retainNode[i]] = this._parentIndex[retainNode[i]];
        const node = this.getNode(retainNode[i]);
        const children = node.children;
        for (let i = 0; i < children.length; i++) {
          retain[children[i].id] = true;
        }
      }
      this._parentIndex = newParentIndex;
      const newData = [];
      for (let i = 0; i < this._data.length; i++) {
        if (this._data[i].n in retain) {
          newData.push(this._data[i]);
        }
      }
      this._data = newData;
    }
    this._subscriberField = {};
    this._loadedField = {};
    this._childrenCache = {};
    this._indexCache = {};
  }

  subscriber(node_id, callback) {
    if (!this._subscriberNode[node_id]) {
      this._subscriberNode[node_id] = [];
    }
    this._subscriberNode[node_id].push(callback);
  }

  subscriberTempId(temp_id, callback) {
    if (!this._subscriberTemp[temp_id]) {
      this._subscriberTemp[temp_id] = [];
    }
    this._subscriberTemp[temp_id].push(callback);
  }

  unSubscriber(node_id, callback = null) {
    if (callback === null) {
      this._subscriberNode[node_id] = [];
    } else {
      for (let i = 0; i < this._subscriberNode[node_id].length; i++) {
        if (this._subscriberNode[node_id][i] === callback) {
          this._subscriberNode[node_id].splice(i, 1);
          break;
        }
      }
    }
    if (!this._subscriberNode[node_id].length) {
      delete this._subscriberNode[node_id];
    }
  }

  unSubscriberTemp(temp_id, callback = null) {
    if (callback === null) {
      this._subscriberTemp[temp_id] = [];
    } else {
      for (let i = 0; i < this._subscriberTemp[temp_id].length; i++) {
        if (this._subscriberTemp[temp_id][i] === callback) {
          this._subscriberTemp[temp_id].splice(i, 1);
          break;
        }
      }
    }
    if (!this._subscriberTemp[temp_id].length) {
      delete this._subscriberTemp[temp_id];
    }
  }

  // 判断是否需要通知订阅节点
  updateSub(nodeMap) {
    // console.log('updateSub');
    const nodeList = {};
    const tempList = {};
    for (let node in nodeMap) {
      if (this.getNode(node).isHide) continue;
      if (
        nodeMap[node][1].new ||
        nodeMap[node][1].title ||
        nodeMap[node][1].prop ||
        nodeMap[node][1].move
      ) {
        if (nodeMap[node][0]) nodeMap[node][1].parentId = nodeMap[node][0];
        const temp_id = this.getNode(node).prop._sys_temp?.[0];
        if (temp_id in this._subscriberTemp) {
          if (!(temp_id in tempList)) tempList[temp_id] = [];
          tempList[temp_id].push(node);
        }
        let n = node;
        let f = true;
        while (n !== null) {
          if (n in this._subscriberNode) {
            if (!(n in nodeList)) nodeList[n] = {};
            nodeList[n][node] = nodeMap[node][1];
            f = false;
            break;
          }
          if (this.hasData(n)) {
            n = this.getData(n).p;
          } else {
            n = null;
          }
        }
        if (f && nodeMap[node][0] !== null) {
          n = nodeMap[node][0];
          while (n !== null) {
            if (n in this._subscriberNode) {
              if (!(n in nodeList)) nodeList[n] = {};
              nodeList[n][node] = nodeMap[node][1];
              break;
            }
            if (this.hasData(n)) {
              n = this.getData(n).p;
            } else {
              n = null;
            }
          }
        }
      }
    }
    for (const n in nodeList) {
      const r = this.sortNodeList(nodeList[n]);
      // console.log(r);
      (this._subscriberNode[n] || []).map((x) => x(r, n));
    }
    for (const temp_id in tempList) {
      const r = tempList[temp_id];
      (this._subscriberTemp[temp_id] || []).map((x) => x(r, temp_id));
    }
  }

  sortNodeList(nodeList) {
    const ret = [];
    for (let node_id in nodeList) {
      ret.push({ node: this.getNode(node_id), change: nodeList[node_id] });
    }
    ret.sort((a, b) => {
      const r = a.node.level - b.node.level;
      if (r !== 0) return r;
      return a.node.index - b.node.index;
    });
    return ret;
  }

  // 更新过滤器叶子节点
  async updateFilterNode(nodeId) {
    if (
      typeof this.getData(nodeId).e._sys_filter_node !== 'object' ||
      this.getData(nodeId).e._sys_filter_node?.constructor?.name !== 'Set'
    ) {
      console.error('updateFilterNode', this.getData(nodeId).e._sys_filter_node);
      return;
    }
    const getList = [];
    for (let n of this.getData(nodeId).e._sys_filter_node) {
      if (!this.hasData(n)) getList.push(n);
    }
    if (getList.length > 0) {
      const data = await this._network.call('/docapi/getNodeNew', {
        method: 'POST',
        data: {
          org_id: this._org_id,
          node_id: getList,
        },
      });
      if (data !== NetWorkError) {
        await this.updateData(data.data);
      }
    }
  }

  filterData(filter) {
    const nodeSet = new Set();
    for (const node_id in this._localData) {
      if (this.filterNodeSync(this._localData[node_id], filter)) {
        if (!this.getNode(node_id).isHide) {
          nodeSet.add(node_id);
        }
      }
    }
    for (const node_id in this._data) {
      if (node_id in this._localData) continue;
      if (this.filterNodeSync(this._data[node_id], filter)) {
        if (!this.getNode(node_id).isHide) {
          nodeSet.add(node_id);
        }
      }
    }
    if (!Array.isArray(filter.groupBy) || filter.groupBy.length === 0) return nodeSet;
    const ret = {};
    for (const node_id of nodeSet) {
      const group = this.getNodeGroup(this.getData(node_id), filter.groupBy, [], filter.interval);
      // console.log(group);
      for (let i = 0; i < group.length; i++) {
        let work = ret;
        for (let j = 0; j < group[i].length; j++) {
          if (!(group[i][j] in work)) {
            work[group[i][j]] = {};
          }
          work = work[group[i][j]];
        }
        work[node_id] = 1;
      }
    }
    return ret;
  }

  // 初始化过滤器
  async initFilter(nodeId, root = true, nodeFilterList = null, update = false) {
    // return;
    if ('_sys_filter' in this.getData(nodeId).e) {
      this.getData(nodeId).e._sys_node_type = root === true ? 3 : 4;
      const s = JSON.stringify(this.getData(nodeId).e._sys_filter);
      if (s.includes(FILTER_SELF_ID)) {
        this.setData(nodeId).e._sys_filter_origin = this.getData(nodeId).e._sys_filter;
        this.setData(nodeId).e._sys_filter = JSON.parse(s.replace(this._selfReg, this._accountId));
      }
    } else {
      return;
    }
    if (nodeId in this._childrenCache) delete this._childrenCache[nodeId];
    if (nodeId in this._indexCache) delete this._indexCache[nodeId];
    const groupBy = this.getData(nodeId).e._sys_filter.groupBy;
    const interval = this.getData(nodeId).e._sys_filter.interval;
    if (root === true) {
      const md5sum = md5(JSON.stringify(this.getData(nodeId).e._sys_filter));
      if (this._filterConfigMd5[nodeId]) {
        if (this._filterConfigMd5[nodeId] !== md5sum) {
          this._filterConfigMd5[nodeId] = md5sum;
          if (nodeId in this._nodeFilterList) delete this._nodeFilterList[nodeId];
          for (let key in this._filterMap) {
            if (this._filterMap[key].has(nodeId)) {
              this._filterMap[key].delete(nodeId);
            }
          }
        }
      } else {
        this._filterConfigMd5[nodeId] = md5sum;
      }
      if (!(this.getData(nodeId).e._sys_filter.temp_id in this._filterMap)) {
        this._filterMap[this.getData(nodeId).e._sys_filter.temp_id] = new Set();
      }
      this._filterMap[this.getData(nodeId).e._sys_filter.temp_id].add(nodeId);
      // 拿过滤器信息`
      if (
        this._expandAll ||
        (this._nodeFilterList[nodeId] && this._nodeFilterList[nodeId].constructor !== Promise)
      ) {
        // 从本地拿
        console.log('initFilter local', nodeId);
        this._nodeFilterList[nodeId] = this.filterData(this.getData(nodeId).e._sys_filter);
      } else if (!this._nodeFilterList[nodeId]) {
        // 从远端拿
        console.log('initFilter remote', nodeId);
        this._nodeFilterList[nodeId] = this._network
          .call('/docapi/getNodeByFilter', {
            method: 'POST',
            data: {
              ...this.getData(nodeId).e._sys_filter,
              org_id: this._org_id,
              onlyId: true,
              nodeId,
            },
          })
          .then((n) => {
            if (Array.isArray(n.data)) return new Set(n.data);
            return n.data;
          });
      }
      if (this._nodeFilterList[nodeId].constructor === Promise) {
        this._nodeFilterList[nodeId] = await this._nodeFilterList[nodeId];
      }
      nodeFilterList = this._nodeFilterList[nodeId];
      root = nodeId;
    }
    if (groupBy.length === 0) {
      if (nodeFilterList.constructor.name === 'Set') {
        // console.log(9991, nodeFilterList);
        this.getData(nodeId).e._sys_filter_node = nodeFilterList;
      } else {
        console.log(9992, nodeFilterList);
        this.getData(nodeId).e._sys_filter_node = new Set(Object.keys(nodeFilterList));
      }
      this.getData(nodeId).e._sys_filter_node.node = nodeId;
      this.getData(nodeId).e._sys_filter_node.root = root;
      for (let node_id of this.getData(nodeId).e._sys_filter_node) {
        if (!(node_id in this._nodeFilterMap)) {
          this._nodeFilterMap[node_id] = { [root]: new Set() };
        } else if (!(root in this._nodeFilterMap[node_id])) {
          this._nodeFilterMap[node_id][root] = new Set();
        }
        this._nodeFilterMap[node_id][root].add(nodeId);
      }
    } else {
      const nodeList = [];
      const groupFilter = [];
      let i = 0;
      // 生成虚拟节点
      const keys = textSort(Object.keys(nodeFilterList));
      if (
        groupBy[0] === 'createTime' ||
        groupBy[0] === 'startTime' ||
        groupBy[0] === 'endTime' ||
        (interval?.length && interval[0])
      ) {
        keys.reverse();
      }
      for (let key of keys) {
        const f = `${groupBy[0]}-${this.encodeNodeId(key)}`;
        const n = `${nodeId}>${f}`;
        const _sys_filter = JSON.parse(JSON.stringify(this.getData(nodeId).e._sys_filter));
        if (!('_inner_filter' in _sys_filter)) _sys_filter._inner_filter = [];
        _sys_filter._inner_filter.push(f);
        _sys_filter.groupBy = _sys_filter.groupBy.slice(1);
        if (Array.isArray(_sys_filter.interval))
          _sys_filter.interval = _sys_filter.interval.slice(1);
        if (i > 0) nodeList[i - 1].j = n;
        nodeList.push({
          n,
          f: this.getData(nodeId).f,
          p: nodeId,
          c: null,
          s: null,
          x: i === 0 ? null : nodeList[i - 1].n,
          j: null,
          e: {
            _sys_readonly: true,
            _sys_protect: true,
            _sys_filter,
          },
          t: key in this._allUser ? this._allUser[key] : key,
        });
        if (Array.isArray(nodeFilterList[key])) {
          nodeFilterList[key] = new Set(nodeFilterList[key]);
        } else if (nodeFilterList[key].constructor.name === 'Set') {
        } else if (valueIsNumber(nodeFilterList[key])) {
          nodeFilterList[key] = new Set(Object.keys(nodeFilterList[key]));
        }
        groupFilter.push(nodeFilterList[key]);
        i++;
      }
      if (nodeList.length > 0) {
        this.getData(nodeId).c = nodeList[0].n;
        this.getData(nodeId).s = nodeList[nodeList.length - 1].n;
        for (let i = 0; i < nodeList.length; i++) {
          this._data[nodeList[i].n] = nodeList[i];
          // 处理下一层过滤器节点
          await this.initFilter(nodeList[i].n, root, groupFilter[i]);
        }
      }
    }
  }

  // 更新数据
  updateData(data) {
    if (!Array.isArray(data)) {
      console.error(`updateData error data = ${String(data)}`);
      return;
    }
    const dataLength = data.length;
    if (dataLength === 0) return;
    let tableNodeNumber = 0;
    const nodeSet = new Set();
    for (let i = 0; i < dataLength; i++) {
      nodeSet.add(data[i].n);
    }
    for (let i = 0; i < dataLength; i++) {
      if (Array.isArray(data[i].e._sys_child) && data[i].e._sys_child.length) {
        for (let j = 0; j < data[i].e._sys_child.length; j++) {
          const child_node = data[i].e._sys_child[j];
          if (nodeSet.has(child_node.n)) continue;
          tableNodeNumber++;
          const node_data = {
            o: this._org_id,
            n: child_node.n,
            c: null,
            e: {
              _sys_user_acl: data[i].e._sys_user_acl,
              _sys_temp: [child_node.q, []],
              _sys_task_status: child_node.s,
            },
            d: child_node.d ?? child_node.i ?? data[i].i,
            f: 4,
            g: 'qd',
            h: child_node.h,
            i: child_node.i ?? data[i].i,
            j: data[i].e._sys_child[j + 1] ?? null,
            l: data[i].l + 1,
            m: child_node.m,
            me: child_node.s?.prop?.[3] ?? null,
            mg: child_node.s?.prop?.[1] ?? [],
            ms: child_node.s?.prop?.[2] ?? null,
            mu: child_node.s?.prop?.[0] ?? null,
            p: data[i].n,
            q: child_node.q,
            r: child_node.s?.index ?? 0,
            s: null,
            t: child_node.t,
            v: 0,
            x: data[i].e._sys_child[j - 1] ?? null,
            content: { ops: [] },
          };
          if (child_node.sa) node_data.e._sys_attach = child_node.sa;
          if (child_node.sl) node_data.e._sys_location = child_node.sl;
          if (child_node.ca) node_data.e._sys_cascade = child_node.ca;
          if (Array.isArray(this._template[child_node.q]?.prop)) {
            prop_for: for (
              let prop_index = 0;
              prop_index < this._template[child_node.q].prop.length;
              prop_index++
            ) {
              if (Array.isArray(this._template[child_node.q].prop[prop_index]?.quoteParent)) {
                for (const quote of this._template[child_node.q].prop[prop_index].quoteParent) {
                  if (
                    quote.parentTemp === data[i].e._sys_temp?.[0] &&
                    quote.enable &&
                    (!quote.op || quote.op === 'p2c')
                  ) {
                    node_data.e._sys_temp[1].push(data[i].e._sys_temp[1]?.[quote.prop] ?? null);
                    continue prop_for;
                  }
                }
              }
              if (prop_index in child_node.p) {
                node_data.e._sys_temp[1].push(child_node.p[prop_index]);
              } else {
                node_data.e._sys_temp[1].push(null);
              }
            }
          }
          data.push(node_data);
          nodeSet.add(child_node.n);
        }
      }
    }
    if (tableNodeNumber) console.log(`通过表格属性加载${tableNodeNumber}个节点`);
    // console.log(`updateData start ${data.length}`);
    let j = 0;
    const filterNode = [];
    const nodeMap = {};
    const moveList = [];
    const updateChildFilter = [];
    for (let i = 0; i < data.length; i++) {
      const node = data[i];
      if (node.f === -2 && node.i !== this._accountId) continue; // 忽略别人的草稿箱
      // 从草稿/回收站移出时额外更新子节点的过滤器信息
      if (
        node.n in this._data &&
        (this._data[node.n].f < 0 || this._data[node.n].f === 2) &&
        node.f >= 0 &&
        node.f !== 2
      ) {
        updateChildFilter.push(node.n);
      }
      nodeMap[node.n] = [null, { new: false, title: false, prop: false, move: false }];
      let f = false;
      if (node.n in this._data) {
        if (this._data[node.n].v <= node.v) {
          if (this.getData(node.n).p !== node.p || this.getData(node.n).x !== node.x) {
            nodeMap[node.n][1].move = true;
          }
          if (node.p !== this._data[node.n].p) {
            nodeMap[node.n][0] = this._data[node.n].p;
            moveList.push(node.n);
            if (this._parentIndex[this._data[node.n].p]?.[node.n])
              delete this._parentIndex[this._data[node.n].p][node.n];
            if (!(node.p in this._parentIndex)) this._parentIndex[node.p] = {};
            this._parentIndex[node.p][node.n] = true;
            if (node.p in this._childrenCache) delete this._childrenCache[node.p];
            if (node.p in this._indexCache) delete this._indexCache[node.p];
            if (this._data[node.n].p in this._childrenCache)
              delete this._childrenCache[this._data[node.n].p];
            if (this._data[node.n].p in this._indexCache)
              delete this._indexCache[this._data[node.n].p];
          } else if (node.j !== this._data[node.n].j || node.x !== this._data[node.n].x) {
            if (node.p in this._childrenCache) delete this._childrenCache[node.p];
            if (node.p in this._indexCache) delete this._indexCache[node.p];
          }
          if (node.c !== this._data[node.n].c || node.s !== this._data[node.n].s) {
            if (node.n in this._childrenCache) delete this._childrenCache[node.n];
            if (node.n in this._indexCache) delete this._indexCache[node.n];
          }
          if (node.t !== this._data[node.n].t) nodeMap[node.n][1].title = true;
          if (JSON.stringify(node.e) !== JSON.stringify(this._data[node.n].e))
            nodeMap[node.n][1].prop = true;
          f = true;
        }
      } else {
        if (!(node.p in this._parentIndex)) this._parentIndex[node.p] = {};
        this._parentIndex[node.p][node.n] = true;
        if (node.p in this._childrenCache) delete this._childrenCache[node.p];
        if (node.n in this._childrenCache) delete this._childrenCache[node.n];
        if (node.p in this._indexCache) delete this._indexCache[node.p];
        if (node.n in this._indexCache) delete this._indexCache[node.n];
        f = true;
        nodeMap[node.n][1].new = true;
      }
      if (f) {
        this._data[node.n] = node;
        // 删除本地数据
        if (node.n in this._localData) delete this._localData[node.n];
        if (node.n in this._localParentIndex) delete this._localParentIndex[node.n];
        j++;
        if ('_sys_filter' in node.e && ((node.f >= 0 && node.f !== 2) || node.f === -3)) {
          filterNode.push(node.n);
        }
      }
    }
    let wt = [];
    if (filterNode.length > 0) {
      wt = filterNode.map((n) => this.initFilter(n));
    }
    // 创建者权限必须扫一遍野节点
    if (this._role === 7) this.updateWildNode();
    // 更新Level
    this.cleanLevel(moveList);
    // 更新过滤器
    const iE = new Set();
    for (const node_id of updateChildFilter) {
      const children = this.getNode(node_id).all_children;
      if (children.length) {
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (child.id in nodeMap || iE.has(child.id)) continue;
          iE.add(child.id);
          data.push(child.metadata);
        }
      }
    }
    wt.push(this.updateFilterData(data, new Set(filterNode)));
    const ret = Promise.all(wt);
    // 如果有订阅
    if (
      Object.keys(this._subscriberNode).length > 0 ||
      Object.keys(this._subscriberTemp).length > 0
    ) {
      ret.then(() => this.updateSub(nodeMap));
    }
    console.log(`updateData end ${j}`);
    return ret;
  }

  async getTempFilterNode(filter) {
    const node_id = md5(JSON.stringify(filter));
    filter.draft = true;
    let r = null;
    if (!this.hasData(node_id)) {
      this._initDone[node_id] = new Promise((resolve) => (r = resolve));
      const node = {
        g: 'qd',
        f: -3,
        v: 1,
        o: this._org_id,
        n: node_id,
        p: null,
        c: null,
        s: null,
        x: null,
        j: null,
        h: Date.now(),
        m: Date.now(),
        i: this._accountId,
        d: this._accountId,
        t: '',
        e: { _sys_filter: filter },
      };
      await this.updateData([node]);
      r();
      delete this._initDone[node_id];
    } else {
      if (this._initDone[node_id]) await this._initDone[node_id];
    }
    return this.getNode(node_id);
  }

  updateFilterData(data, skipNode = new Set()) {
    // console.log('updateFilterData', data.length);
    const updateList = new Set();
    const initList = new Set();
    for (let i = 0; i < data.length; i++) {
      if (data[i].n in this._nodeFilterMap) {
        // 清理旧数据
        const deleteList = new Set();
        for (const filterNodeId in this._nodeFilterMap[data[i].n]) {
          if (skipNode.has(filterNodeId)) continue;
          deleteList.add(filterNodeId);
          for (let node_id of this._nodeFilterMap[data[i].n][filterNodeId]) {
            if (this.hasData(node_id)) {
              this.getData(node_id).e._sys_filter_node.delete(data[i].n);
            } else {
              console.error('not found', node_id);
            }
          }
        }
        for (const filterNodeId of deleteList) {
          delete this._nodeFilterMap[data[i].n][filterNodeId];
        }
      }
      for (const temp_id of [data[i].e?._sys_temp?.[0], null, undefined]) {
        if (temp_id in this._filterMap) {
          // 增加新数据
          for (const filterNodeId of this._filterMap[temp_id]) {
            if (
              skipNode.has(filterNodeId) ||
              initList.has(filterNodeId) ||
              updateList.has(filterNodeId)
            )
              continue;
            if (
              data[i].e._sys_filter &&
              (!(filterNodeId in this._nodeFilterList) ||
                this._filterConfigMd5[filterNodeId] !== md5(JSON.stringify(data[i].e._sys_filter)))
            ) {
              initList.add(filterNodeId);
            } else if (this.updateNodeFilterList(filterNodeId, data[i])) {
              updateList.add(filterNodeId);
            }
          }
        }
      }
    }
    const wt = [];
    for (const filterNodeId of initList) {
      wt.push(this.initFilter(filterNodeId, true, null, false));
    }
    for (const filterNodeId of updateList) {
      if (initList.has(filterNodeId)) continue;
      wt.push(this.initFilter(filterNodeId, true, null, true));
    }
    if (wt.length) {
      return Promise.all(wt);
    }
    return [];
  }

  updateNodeFilterList(filterNodeId, nodeData) {
    // 判断是否被过滤
    const filter = this.getData(filterNodeId).e._sys_filter;
    if (!this.filterNodeSync(nodeData, filter)) return false;
    if (this._role === 7 && this.getNode(nodeData.n).isHide) return false;
    // 计算需要加到哪些分组， 更新_nodeFilterList
    let ret = false;
    const group = this.getNodeGroup(nodeData, filter.groupBy || [], [], filter.interval);
    // console.log(group);
    for (let i = 0; i < group.length; i++) {
      let g = this._nodeFilterList[filterNodeId];
      for (let j = 0; j < group[i].length - 1; j++) {
        if (!(group[i][j] in g)) {
          g[group[i][j]] = {};
        }
        g = g[group[i][j]];
      }
      if (group[i].length === 0) {
        g.add(nodeData.n);
      } else {
        if (!(group[i][group[i].length - 1] in g)) {
          ret = true;
          g[group[i][group[i].length - 1]] = new Set();
        } else {
          if (g[group[i][group[i].length - 1]]?.root) {
            if (!(nodeData.n in this._nodeFilterMap)) {
              this._nodeFilterMap[nodeData.n] = {
                [g[group[i][group[i].length - 1]].root]: new Set(),
              };
            } else if (
              !(g[group[i][group[i].length - 1]].root in this._nodeFilterMap[nodeData.n])
            ) {
              this._nodeFilterMap[nodeData.n][g[group[i][group[i].length - 1]].root] = new Set();
            }
            this._nodeFilterMap[nodeData.n][g[group[i][group[i].length - 1]].root].add(
              g[group[i][group[i].length - 1]].node,
            );
          }
        }
        g[group[i][group[i].length - 1]].add(nodeData.n);
      }
    }
    /*console.log(
      'updateNodeFilterList',
      filterNodeId,
      nodeData.n,
      nodeData.f,
      this._nodeFilterList[filterNodeId],
      filter,
    );*/
    // 如果有新的分组则返回True触发initFilter
    return ret;
  }

  filterNodeSync(nodeData, filter) {
    const recycle = filter.recycle || false;
    const temp_id = filter.temp_id || null;
    const keyWords = filter.keyWords || [];
    const onlyTitle = filter.onlyTitle || false;
    const includeProp = filter.includeProp || false;
    const tempProps = (filter.tempProps || []).filter((n) => !Array.isArray(n) || n.length > 0);
    const filterTime = convertFilterTime(filter.filterTime || {});
    const createUser = filter.createUser || null;
    const modifyUser = filter.modifyUser || null;
    const draft = filter.draft || false;
    let parentId = filter.parentId || null;
    let deep = {};
    if (typeof parentId === 'string') {
      if (parentId.length) {
        parentId = [parentId];
      } else {
        parentId = null;
      }
    } else if (typeof parentId === 'object' && parentId !== null && !Array.isArray(parentId)) {
      deep = parentId;
      parentId = Object.keys(deep);
    }
    if (recycle) {
      if (nodeData.f !== 2) return false;
    } else {
      if (draft) {
        if (nodeData.f === 2 || nodeData.f === -1) return false;
      } else {
        if (nodeData.f === 2 || nodeData.f < 0) return false;
      }
    }
    if (createUser !== null) {
      if (nodeData.i !== createUser) return false;
    }
    if (modifyUser !== null) {
      if (nodeData.d !== modifyUser) return false;
    }
    const filterTimeKey = Object.keys(filterTime);
    if (filterTimeKey.length > 0) {
      for (let i = 0; i < filterTimeKey.length; i++) {
        const t = nodeData[sortByColumnMap[filterTimeKey[i]]];
        if (t < filterTimeKey[filterTimeKey[i]][0] || t > filterTime[filterTimeKey[i]][1])
          return false;
      }
    }
    if (temp_id !== null) {
      if (Array.isArray(temp_id)) {
        if (!temp_id.includes(nodeData.e?._sys_temp?.[0])) return false;
      } else {
        if (nodeData.e?._sys_temp?.[0] !== temp_id) return false;
      }
    }

    if (tempProps.length > 0) {
      let mp;
      if ('mp' in nodeData) {
        if (Array.isArray(nodeData.mp)) {
          mp = nodeData.mp;
        } else {
          mp = convertIndexProp(nodeData.e);
          nodeData.mp = mp;
        }
      } else {
        mp = convertIndexProp(nodeData.e);
        nodeData.mp = mp;
      }
      for (let i = 0; i < tempProps.length; i++) {
        if (Array.isArray(tempProps[i])) {
          let f = false;
          for (let j = 0; j < tempProps[i].length; j++) {
            if (mp.includes(tempProps[i][j])) {
              f = true;
              break;
            }
          }
          if (!f) return false;
        } else {
          if (!mp.includes(tempProps[i])) return false;
        }
      }
    }
    if (Array.isArray(parentId) && parentId.length > 0) {
      let f = false;
      for (let i = 0; i < parentId.length; i++) {
        if (this.isAnc(nodeData, parentId[i], deep[parentId[i]])) {
          f = true;
          break;
        }
      }
      if (!f) return false;
    }
    if (Array.isArray(keyWords) && keyWords.length) {
      let f = false;
      const dc = onlyTitle ? null : JSON.stringify(nodeData.content?.ops);
      const prop = includeProp ? JSON.stringify(nodeData.e) : null;
      for (const k of keyWords) {
        if (nodeData.t.includes(k)) {
          f = true;
          break;
        }
        if (onlyTitle) continue;
        if (dc.includes(k) || (includeProp && prop.includes(k))) {
          f = true;
          break;
        }
      }
      if (!f) return false;
    }
    if (filter.conditionV2) {
      for (const conditionV2 of filter.conditionV2) {
        if (!this.conditionV2Filter(nodeData, conditionV2)) return false;
      }
    }
    return true;
  }

  conditionV2Filter(nodeData, condition) {
    switch (condition.op) {
      case 'and':
        for (const c of condition.input) {
          if (!this.conditionV2Filter(nodeData, c)) return false;
        }
        return true;
      case 'or':
        for (const c of condition.input) {
          if (this.conditionV2Filter(nodeData, c)) return true;
        }
        return false;
      case 'include':
        for (const c of condition.input) {
          if (!this.conditionV2Filter(nodeData, { op: 'intersect', input: [c] })) return false;
        }
        return true;
      case 'notInclude':
        for (const c of condition.input) {
          if (this.conditionV2Filter(nodeData, { op: 'intersect', input: [c] })) return false;
        }
        return true;
      case 'beIncluded':
      case 'intersect':
        switch (condition.key) {
          case 'templateId':
            for (const c of condition.input) {
              if (nodeData.e._sys_temp?.[0] === c) return true;
            }
            return false;
          case 'ancestor':
            for (const c of condition.input) {
              if (this.isAnc(nodeData, c)) return true;
            }
            return false;
          case 'prop':
            if (
              condition.input.includes('_filter_unset') &&
              nodeData.e._sys_temp?.[1]?.[condition.index] === null
            )
              return true;
            if (condition.input?.every?.((n) => typeof n === 'number')) {
              for (let n of Array.isArray(nodeData.e._sys_temp?.[1]?.[condition.index])
                ? nodeData.e._sys_temp[1][condition.index]
                : [nodeData.e._sys_temp?.[1]?.[condition.index]]) {
                switch (typeof n) {
                  case 'string':
                    if (n.includes('.')) {
                      n = parseFloat(n);
                    } else {
                      n = parseInt(n);
                    }
                  case 'number':
                    if (!Number.isFinite(n)) continue;
                    break;
                  default:
                    continue;
                }
                for (const c of condition.input) {
                  if (Math.abs(n - c) < 1e-8) return true;
                }
              }
            } else {
              if (Array.isArray(nodeData.e._sys_temp?.[1]?.[condition.index])) {
                for (const c of condition.input) {
                  if (nodeData.e._sys_temp[1][condition.index].includes(c)) return true;
                }
              } else {
                for (const c of condition.input) {
                  if (nodeData.e._sys_temp?.[1]?.[condition.index] === c) return true;
                }
              }
            }
            return false;
          case 'status':
            for (const c of condition.input) {
              if (typeof c === 'string' && c.endsWith('_history')) {
                if (
                  Array.isArray(nodeData.e._sys_osp) &&
                  nodeData.e._sys_osp.includes(`s-${c.split('_')[0]}-i`)
                )
                  return true;
              } else {
                if (nodeData.e._sys_task_status?.index === c) return true;
              }
            }
            return false;
          case 'statusProp':
            if (Array.isArray(nodeData.e._sys_task_status?.prop?.[condition.index])) {
              for (const c of condition.input) {
                if (nodeData.e._sys_task_status.prop[condition.index].includes(c)) return true;
              }
            } else {
              for (const c of condition.input) {
                if (nodeData.e._sys_task_status?.prop?.[condition.index] === c) return true;
              }
            }
            return false;
          case 'templateStatusOwnerAndParticipant':
            return (
              this.conditionV2Filter(nodeData, {
                op: 'intersect',
                key: 'statusProp',
                input: condition.input,
                index: 0,
              }) ||
              this.conditionV2Filter(nodeData, {
                op: 'intersect',
                key: 'statusProp',
                input: condition.input,
                index: 1,
              })
            );
          case 'sysTag':
            if (typeof nodeData.e._sys_tag === 'object' && nodeData.e._sys_tag !== null) {
              for (const c of condition.input) {
                if (c in nodeData.e._sys_tag) return true;
              }
            }
            return false;
          case 'sysCreator':
            for (const c of condition.input) {
              if (nodeData.i === c) return true;
            }
            return false;
          case 'sysModifyUser':
            for (const c of condition.input) {
              if (nodeData.d === c) return true;
            }
            return false;
          case 'sysCreateTime':
          default:
            console.error('not support', condition.key);
            return true;
        }
      case 'textInclude':
        switch (condition.key) {
          case 'prop': {
            let target = null;
            if (Array.isArray(nodeData.e._sys_temp?.[1]?.[condition.index])) {
              if (
                nodeData.e._sys_temp[1][condition.index].length === 1 &&
                typeof nodeData.e._sys_temp[1][condition.index][0] === 'string'
              ) {
                target = nodeData.e._sys_temp[1][condition.index][0];
              }
            } else if (typeof nodeData.e._sys_temp[1][condition.index] === 'string') {
              target = nodeData.e._sys_temp[1][condition.index];
            }
            if (target === null) return false;
            for (const v of condition.input) {
              if (!target.includes(v)) return false;
            }
            return true;
          }
          case 'statusProp': {
            let target = null;
            if (Array.isArray(nodeData.e._sys_task_status?.prop?.[condition.index])) {
              if (
                nodeData.e._sys_task_status?.prop?.[condition.index].length === 1 &&
                typeof nodeData.e._sys_task_status.prop[condition.index][0] === 'string'
              ) {
                target = nodeData.e._sys_task_status.prop[condition.index][0];
              }
            } else if (typeof nodeData.e._sys_task_status.prop[condition.index] === 'string') {
              target = nodeData.e._sys_task_status.prop[condition.index];
            }
            if (target === null) return false;
            for (const v of condition.input) {
              if (!target.includes(v)) return false;
            }
            return true;
          }
          default:
            return false;
        }
      case 'notEmpty':
        return !this.conditionV2Filter(nodeData, { ...condition, op: 'empty' });
      case 'empty':
        switch (condition.key) {
          case 'prop':
            return Array.isArray(nodeData.e._sys_temp?.[1]?.[condition.index])
              ? nodeData.e._sys_temp[1][condition.index].length === 0
              : nodeData.e._sys_temp?.[1]?.[condition.index] === null ||
                  nodeData.e._sys_temp?.[1]?.[condition.index] === '' ||
                  nodeData.e._sys_temp?.[1]?.[condition.index] === undefined;
          case 'statusProp':
            return Array.isArray(nodeData.e._sys_task_status?.prop?.[condition.index])
              ? nodeData.e._sys_task_status.prop[condition.index].length === 0
              : nodeData.e._sys_task_status?.prop?.[condition.index] === null ||
                  nodeData.e._sys_task_status?.prop?.[condition.index] === '' ||
                  nodeData.e._sys_task_status?.prop?.[condition.index] === undefined;
          case 'templateStatusOwnerAndParticipant':
            if (Array.isArray(nodeData.e._sys_task_status?.prop?.[0])) {
              if (nodeData.e._sys_task_status.prop[0].length) return false;
            } else if (nodeData.e._sys_task_status?.prop?.[0]) {
              return false;
            }
            if (Array.isArray(nodeData.e._sys_task_status?.prop?.[1])) {
              if (nodeData.e._sys_task_status.prop[1].length) return false;
            } else if (nodeData.e._sys_task_status?.prop?.[1]) {
              return false;
            }
            return true;
          case 'sysTag':
            return !Object.keys(nodeData.e._sys_tag || {}).length;
          default:
            return false;
        }
      case 'distance':
        if (condition.key === 'prop') {
          let target = nodeData.e._sys_location?.[condition.index];
          if (Array.isArray(target)) target = target[0];
          if (
            typeof target?.lat === 'number' &&
            typeof target?.lng === 'number' &&
            typeof condition.input?.[0]?.lat === 'number' &&
            typeof condition.input?.[0]?.lng === 'number' &&
            typeof condition.input?.[1] === 'number'
          ) {
            return (
              calcDistance(
                target.lat,
                target.lng,
                condition.input[0].lat,
                condition.input[0].lng,
              ) <= condition.input[1]
            );
          }
        }
        return false;
      case 'rangeEqualProv':
      case 'rangeEqualCity':
      case 'rangeEqualDist':
      case 'rangeEqualStreet':
        if (condition.key === 'prop') {
          let target = nodeData.e._sys_location?.[condition.index];
          if (Array.isArray(target)) target = target[0];
          return target?.[condition.op.slice(10).toLowerCase()] === condition.input[0];
        }
        return false;
      case 'less':
      case 'timeBefore': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'string') {
          target = parseInt(target);
          if (!Number.isInteger(target)) return false;
        }
        if (typeof target === 'number') {
          return target < condition.input[0];
        }
        return false;
      }
      case 'lessEqual':
      case 'timeBeforeEqual': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'string') {
          target = parseInt(target);
          if (!Number.isInteger(target)) return false;
        }
        if (typeof target === 'number') {
          return target <= condition.input[0];
        }
        return false;
      }
      case 'greaterEqual':
      case 'timeAfterEqual': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'string') {
          target = parseInt(target);
          if (!Number.isInteger(target)) return false;
        }
        if (typeof target === 'number') {
          return target >= condition.input[0];
        }
        return false;
      }
      case 'equal':
      case 'timeEqual': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'string') {
          target = parseInt(target);
          if (!Number.isInteger(target)) return false;
        }
        if (typeof target === 'number') {
          return target === condition.input[0];
        }
        return false;
      }

      case 'greater':
      case 'timeAfter': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'string') {
          target = parseInt(target);
          if (!Number.isInteger(target)) return false;
        }
        if (typeof target === 'number') {
          return target > condition.input[0];
        }
        return false;
      }
      case 'notEqual': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'string') {
          target = parseInt(target);
          if (!Number.isInteger(target)) return false;
        }
        if (typeof target === 'number') {
          return target !== condition.input[0];
        }
        return false;
      }
      case 'timeBein': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          case 'sysCreateTime':
            target = nodeData.h;
            break;
          default:
            return false;
        }
        if (!Array.isArray(target)) target = [target];
        for (let t of target) {
          if (typeof t === 'string') {
            t = parseInt(t);
            if (!Number.isInteger(t)) continue;
          }
          if (typeof t === 'number') {
            if (condition.input.length > 2 && typeof condition.input[2] === 'number') {
              if (
                t >=
                  dayjs()
                    .add(0 - condition.input[2], 'd')
                    .startOf('d')
                    .valueOf() &&
                t <= dayjs().endOf('d').valueOf()
              )
                return true;
            } else {
              if (t >= condition.input[0] && t <= condition.input[1]) return true;
            }
          }
        }
        return false;
      }
      case 'dayInclude': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'number') {
          return getDayStamp(target) === getDayStamp(condition.input[0]);
        }
        return false;
      }
      case 'monthInclude': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'number') {
          return (
            getCompatibleDate(target).getUTCMonth() ===
              getCompatibleDate(condition.input[0]).getUTCMonth() &&
            getCompatibleDate(target).getUTCFullYear() ===
              getCompatibleDate(condition.input[0]).getUTCFullYear()
          );
        }
        return false;
      }
      case 'yearInclude': {
        let target;
        switch (condition.key) {
          case 'prop':
            target = nodeData.e._sys_temp?.[1]?.[condition.index];
            break;
          case 'statusProp':
            target = nodeData.e._sys_task_status?.prop?.[condition.index];
            break;
          default:
            return false;
        }
        if (Array.isArray(target)) target = target[0];
        if (typeof target === 'number') {
          return (
            getCompatibleDate(target).getUTCFullYear() ===
            getCompatibleDate(condition.input[0]).getUTCFullYear()
          );
        }
        return false;
      }
      case 'rangeEqualCascade':
      default:
        console.error('not support', condition.op);
        return true;
    }
  }

  getNodeGroup(nodeData, groupBy, path = [], interval = []) {
    if (groupBy.length === 0) return [path];
    let prop = null;
    switch (groupBy[0]) {
      case 'createTime':
        prop = convertDateTime(nodeData.h, interval?.[(interval?.length || 0) - groupBy.length]);
        break;
      case 'createUser':
        prop = nodeData.i;
        break;
      case 'startTime':
        prop = convertDateTime(nodeData.ms, interval?.[(interval?.length || 0) - groupBy.length]);
        break;
      case 'endTime':
        prop = convertDateTime(nodeData.me, interval?.[(interval?.length || 0) - groupBy.length]);
        break;
      case 't':
      case 'tag':
        prop = Object.keys(nodeData.e._sys_tag || {});
        break;
      default:
        switch (groupBy[0].charAt(0)) {
          case 'p':
            prop = nodeData.e._sys_temp?.[1]?.[parseInt(groupBy[0].slice(1))];
            if (interval?.[(interval?.length || 0) - groupBy.length])
              prop = convertDateTime(prop, interval?.[(interval?.length || 0) - groupBy.length]);
            break;
          case 's':
            if (groupBy[0] === 'si') {
              prop =
                this._template[nodeData.e._sys_temp?.[0]]?.task_status?.[
                  nodeData.e._sys_task_status?.index || 0
                ]?.name;
            } else {
              let isGroup;
              switch (groupBy[0]) {
                case 'so':
                case 'sog':
                  isGroup = groupBy[0] === 'sog';
                  prop = [];
                  if (typeof nodeData.e._sys_task_status?.prop?.[0] === 'string') {
                    prop.push(nodeData.e._sys_task_status.prop[0]);
                  } else if (Array.isArray(nodeData.e._sys_task_status?.prop?.[0])) {
                    prop.push.apply(prop, nodeData.e._sys_task_status.prop[0]);
                  }
                  if (typeof nodeData.e._sys_task_status?.prop?.[1] === 'string') {
                    prop.push(nodeData.e._sys_task_status.prop[1]);
                  } else if (Array.isArray(nodeData.e._sys_task_status?.prop?.[1])) {
                    prop.push.apply(prop, nodeData.e._sys_task_status.prop[1]);
                  }
                  break;
                default:
                  isGroup = groupBy[0].charAt(1) === 'g';
                  prop =
                    nodeData.e._sys_task_status?.prop?.[
                      parseInt(groupBy[0].slice(isGroup ? 2 : 1))
                    ];
                  if (!(prop === null || prop === undefined) && !Array.isArray(prop)) {
                    prop = [prop];
                  }
              }
              if (isGroup) {
                if (!Array.isArray(prop)) {
                  prop = [prop];
                }
                prop = Array.from(new Set(prop.map((ad) => this._groupMap[ad] ?? ['-4']).flat()));
              }
              prop = Array.from(new Set(prop));
            }
        }
    }
    if (prop === null || prop === undefined) {
      prop = '(未定义)';
    } else {
      if (typeof prop === 'object' && 'props' in prop) {
        prop = prop.props;
      }
    }
    if (!Array.isArray(prop)) {
      if (typeof prop === 'number') prop = prop.toString();
      prop = [prop];
    } else {
      if (prop.length === 0) {
        prop = ['(未定义)'];
      } else {
        for (let i = 0; i < prop.length; i++) {
          if (typeof prop[i] === 'number') prop[i] = prop[i].toString();
        }
      }
    }
    const ret = [];
    for (let i = 0; i < prop.length; i++) {
      ret.push.apply(
        ret,
        this.getNodeGroup(nodeData, groupBy.slice(1), [...path, prop[i]], interval),
      );
    }
    return ret;
  }

  cleanLevel(nodeList) {
    for (let i = 0; i < nodeList.length; i++) {
      const n = this.getNode(nodeList[i]);
      n.cleanLevel();
    }
  }

  // 更新野节点
  updateWildNode() {
    // console.log('update wild node');
    const wildNode = {};
    for (let i in this._data) {
      if (this._data[i].iH || !this.isRead(this._data[i].e)) continue;
      if (this._data[i].f === 2 || this._data[i].f < 0) continue;
      if (
        this._data[i].iW ||
        (this._data[i].p !== null &&
          (this._data.hasOwnProperty(this._data[i].p)
            ? this._data[this._data[i].p].iH || !this.isRead(this._data[this._data[i].p].e)
            : true))
      ) {
        wildNode[i] = true;
        this._data[i].iW = true;
      }
    }
    this._wildNode = wildNode;
    if (this._rootId in this._childrenCache) delete this._childrenCache[this._rootId];
    if (this._rootId in this._indexCache) delete this._indexCache[this._rootId];
  }

  convertVersionList(versionList) {
    return versionList.map((v) => Math.max(...Object.keys(v).map((a) => parseInt(a, 36))));
  }

  // 清空一个区域，更新回收站时使用
  // TODO 回收站也要用getChange
  cleanField(field) {
    const data = {};
    for (let i in this._data) {
      if (this._data[i].f !== field) {
        data[i] = this._data[i];
      } else {
        if (this._data[i].p in this._childrenCache) delete this._childrenCache[this._data[i].p];
        if (this._data[i].n in this._childrenCache) delete this._childrenCache[this._data[i].n];
        if (this._data[i].p in this._indexCache) delete this._indexCache[this._data[i].p];
        if (this._data[i].n in this._indexCache) delete this._indexCache[this._data[i].n];
        if (this._parentIndex[this._data[i].p]?.[this._data[i].n])
          delete this._parentIndex[this._data[i].p][this._data[i].n];
      }
    }
    this._data = data;
  }

  async convertBufToRaw(data) {
    let buf = null;
    const t1 = Date.now();
    while (true) {
      const { done, value } = await data.read();
      if (done) break;
      let offset = 0;
      let block_length;
      if (buf === null) {
        buf = value;
      } else {
        buf = concat(buf, value);
      }
      while (offset + 1024 <= buf.length) {
        block_length = UInt16LE(buf, offset + NODE_DATA_OFFSET.block_size) << 10;
        if (offset + block_length > buf.length) {
          // block不完整
          break;
        }
        const block = buf.subarray(offset, offset + block_length);
        let node_id = hex16(block, NODE_DATA_OFFSET.node_id);
        let parent_id = hex16(block, NODE_DATA_OFFSET.parent_id);
        if (node_id.endsWith('00000000000000000000')) {
          node_id = node_id.slice(0, 12);
        }
        if (parent_id === '00000000000000000000000000000000') {
          parent_id = null;
        } else if (parent_id.endsWith('00000000000000000000')) {
          parent_id = parent_id.slice(0, 12);
        }
        if (node_id === this._rootId) {
          this._rawRoot = block;
        } else {
          if (!(parent_id in this._rawParent)) {
            this._rawParent[parent_id] = [];
          }
          this._rawParent[parent_id].push(block);
        }
        offset += block_length;
      }
    }
    console.log(`convertBufToRaw cost ${Date.now() - t1} ms`);
  }

  async convertSingleBuf(buf, nodeData, nodeMap, skipExists = true) {
    let offset = 0;
    const wt = [];
    while (offset + 1024 <= buf.length) {
      const block_length = UInt16LE(buf, offset + NODE_DATA_OFFSET.block_size) << 10;
      if (offset + block_length > buf.length) {
        // block不完整
        break;
      }
      const node_type = utf8decoder.decode(
        buf.subarray(offset + NODE_DATA_OFFSET.node_type, offset + NODE_DATA_OFFSET.node_type + 2),
      );
      let block = null,
        d;
      if (node_type === 'se') {
        this._sec_node_count++;
        // 加密节点
        let sec_key = null;
        if (this._sec_key.sec_key) {
          /*sec_key = await window.crypto.subtle.digest(
            SHA256,
            Buffer.concat([
              toBuffer(
                buf.subarray(
                  offset + NODE_DATA_OFFSET.node_id,
                  offset + NODE_DATA_OFFSET.node_id + 16,
                ),
              ),
              Buffer.from(this._sec_key.sec_key, 'hex'),
            ]),
          );*/
          sec_key = sha256(
            concat(
              buf.subarray(
                offset + NODE_DATA_OFFSET.node_id,
                offset + NODE_DATA_OFFSET.node_id + 16,
              ),
              unhex(this._sec_key.sec_key),
            ),
            null,
          );
        } else {
          const node_id = hex16(buf, offset + NODE_DATA_OFFSET.node_id);
          if (node_id in this._sec_key.node_sec_key) {
            sec_key = unhex(this._sec_key.node_sec_key[node_id]);
          }
        }
        if (sec_key === null) {
          const subarray = buf.subarray(offset, offset + block_length);
          d = {
            g: node_type,
            f: Int32LE(subarray, NODE_DATA_OFFSET.field),
            v: new Uint64LE(
              subarray.subarray(NODE_DATA_OFFSET.version, NODE_DATA_OFFSET.version + 8),
            ).toNumber(),
            o: HEX16(subarray, NODE_DATA_OFFSET.org_id),
            n: hex16(subarray, NODE_DATA_OFFSET.node_id),
            p: hex16(subarray, NODE_DATA_OFFSET.parent_id),
            c: '00000000000000000000000000000000',
            s: '00000000000000000000000000000000',
            x: hex16(subarray, NODE_DATA_OFFSET.forward_node),
            j: hex16(subarray, NODE_DATA_OFFSET.next_node),
            e: {},
            content: { ops: [] },
            iH: 1,
          };
        } else {
          const cipher_length = UInt32LE(buf, offset + NODE_DATA_OFFSET.cipher_length);
          /*block = Buffer.concat([
            buf.subarray(offset, offset + NODE_DATA_OFFSET.cipher_length),
            Buffer(
              await window.crypto.subtle.decrypt(
                {
                  name: 'AES-CBC',
                  iv: this._sec_key.iv,
                },
                await window.crypto.subtle.importKey(
                  'raw',
                  sec_key,
                  { name: 'AES-CBC', length: 256 },
                  false,
                  ['decrypt'],
                ),
                buf.subarray(
                  offset + NODE_DATA_OFFSET.cipher,
                  offset + NODE_DATA_OFFSET.cipher + cipher_length,
                ),
              ),
            ),
          ]);*/
          const un_cipher_data = buf.subarray(offset, offset + NODE_DATA_OFFSET.cipher_length);
          const cipher_data = buf.subarray(
            offset + NODE_DATA_OFFSET.cipher,
            offset + NODE_DATA_OFFSET.cipher + cipher_length,
          );
          wt.push(
            window.crypto.subtle
              .importKey('raw', sec_key, AES_256_CBC, false, USAGE)
              .then(async (key) => {
                const enc_data = await window.crypto.subtle.decrypt(
                  {
                    name: 'AES-CBC',
                    iv: this._sec_key.iv,
                  },
                  key,
                  cipher_data,
                );
                const block = concat(un_cipher_data, new Uint8Array(enc_data));
                const title_length = UInt16LE(block, NODE_DATA_OFFSET.title_length);
                const prop_length = UInt32LE(block, NODE_DATA_OFFSET.prop_length);
                const content_length = UInt32LE(block, NODE_DATA_OFFSET.content_length);
                const d = {
                  g: node_type,
                  f: Int32LE(block, NODE_DATA_OFFSET.field),
                  v: new Uint64LE(
                    block.subarray(NODE_DATA_OFFSET.version, NODE_DATA_OFFSET.version + 8),
                  ).toNumber(),
                  o: this._org_id,
                  n: hex16(block, NODE_DATA_OFFSET.node_id),
                  p: hex16(block, NODE_DATA_OFFSET.parent_id),
                  c: hex16(block, NODE_DATA_OFFSET.first_child),
                  s: hex16(block, NODE_DATA_OFFSET.last_child),
                  x: hex16(block, NODE_DATA_OFFSET.forward_node),
                  j: hex16(block, NODE_DATA_OFFSET.next_node),
                  h: new Uint64LE(
                    block.subarray(NODE_DATA_OFFSET.create_time, NODE_DATA_OFFSET.create_time + 8),
                  ).toNumber(),
                  m: new Uint64LE(
                    block.subarray(NODE_DATA_OFFSET.modify_time, NODE_DATA_OFFSET.modify_time + 8),
                  ).toNumber(),
                  i: HEX16(block, NODE_DATA_OFFSET.creator),
                  d: HEX16(block, NODE_DATA_OFFSET.modify_user),
                  t: utf8decoder.decode(
                    block.subarray(NODE_DATA_OFFSET.title, NODE_DATA_OFFSET.title + title_length),
                  ),
                  e: JSON.parse(
                    utf8decoder.decode(
                      block.subarray(
                        NODE_DATA_OFFSET.title + title_length,
                        NODE_DATA_OFFSET.title + title_length + prop_length,
                      ),
                    ),
                  ),
                  content: JSON.parse(
                    utf8decoder.decode(
                      block.subarray(
                        NODE_DATA_OFFSET.title + title_length + prop_length,
                        NODE_DATA_OFFSET.title + title_length + prop_length + content_length,
                      ),
                    ),
                  ),
                };
                for (const key of ['p', 'x', 'j', 'c', 's']) {
                  if (d[key] === '00000000000000000000000000000000') {
                    d[key] = null;
                  } else if (d[key].slice(12) === '00000000000000000000') {
                    d[key] = d[key].slice(0, 12);
                  }
                }
                if (d.n.slice(12) === '00000000000000000000') {
                  d.n = d.n.slice(0, 12);
                }
                if (d.f === 2 && (d.p === null || d.p === this._org_id_lower))
                  d.p = this._deletePid;
                if (d.n in nodeMap) {
                  nodeData[nodeMap[d.n]] = d;
                } else {
                  nodeMap[d.n] = nodeData.push(d) - 1;
                }
              })
              .catch((e) => console.error(e)),
          );
        }
      } else {
        block = buf.subarray(offset, offset + block_length);
      }
      if (block) {
        const title_length = UInt16LE(block, NODE_DATA_OFFSET.title_length);
        const prop_length = UInt32LE(block, NODE_DATA_OFFSET.prop_length);
        const content_length = UInt32LE(block, NODE_DATA_OFFSET.content_length);
        d = {
          g: node_type,
          f: Int32LE(block, NODE_DATA_OFFSET.field),
          v: new Uint64LE(
            block.subarray(NODE_DATA_OFFSET.version, NODE_DATA_OFFSET.version + 8),
          ).toNumber(),
          o: this._org_id,
          n: hex16(block, NODE_DATA_OFFSET.node_id),
          p: hex16(block, NODE_DATA_OFFSET.parent_id),
          c: hex16(block, NODE_DATA_OFFSET.first_child),
          s: hex16(block, NODE_DATA_OFFSET.last_child),
          x: hex16(block, NODE_DATA_OFFSET.forward_node),
          j: hex16(block, NODE_DATA_OFFSET.next_node),
          h: new Uint64LE(
            block.subarray(NODE_DATA_OFFSET.create_time, NODE_DATA_OFFSET.create_time + 8),
          ).toNumber(),
          m: new Uint64LE(
            block.subarray(NODE_DATA_OFFSET.modify_time, NODE_DATA_OFFSET.modify_time + 8),
          ).toNumber(),
          i: HEX16(block, NODE_DATA_OFFSET.creator),
          d: HEX16(block, NODE_DATA_OFFSET.modify_user),
          t: utf8decoder.decode(
            block.subarray(NODE_DATA_OFFSET.title, NODE_DATA_OFFSET.title + title_length),
          ),
          e: JSON.parse(
            utf8decoder.decode(
              block.subarray(
                NODE_DATA_OFFSET.title + title_length,
                NODE_DATA_OFFSET.title + title_length + prop_length,
              ),
            ),
          ),
          content: JSON.parse(
            utf8decoder.decode(
              block.subarray(
                NODE_DATA_OFFSET.title + title_length + prop_length,
                NODE_DATA_OFFSET.title + title_length + prop_length + content_length,
              ),
            ),
          ),
        };
        // data.q = data.e?._sys_temp?.[0] || null;
        // data.r = data.e?._sys_task_status?.prop?.index ?? null;
        // data.ms = data.e?._sys_task_status?.prop?.[2] ?? null;
        // data.me = data.e?._sys_task_status?.prop?.[3] ?? null;
        // data.mu = data.e?._sys_task_status?.prop?.[0] ?? null;
        // data.mg = data.e?._sys_task_status?.prop?.[1] ?? null;
        for (const key of ['p', 'x', 'j', 'c', 's']) {
          if (d[key] === '00000000000000000000000000000000') {
            d[key] = null;
          } else if (d[key].slice(12) === '00000000000000000000') {
            d[key] = d[key].slice(0, 12);
          }
        }
        if (d.n.slice(12) === '00000000000000000000') {
          d.n = d.n.slice(0, 12);
        }
        if (!(skipExists && this._data[d.n])) {
          if (d.f === 2 && (d.p === null || d.p === this._org_id_lower)) d.p = this._deletePid;
          if (d.n in nodeMap) {
            nodeData[nodeMap[d.n]] = d;
          } else {
            nodeMap[d.n] = nodeData.push(d) - 1;
          }
        }
      }
      offset += block_length;
    }
    if (offset === buf.length) {
      // 正好结束
      buf = null;
    } else {
      buf = buf.subarray(offset);
    }
    if (wt.length) await Promise.all(wt);
    return buf;
  }

  async convertBufToJson(data, nodeData, nodeMap) {
    let buf = null;
    const t1 = Date.now(),
      t2 = nodeData.length;
    while (true) {
      const { done, value } = await data.read();
      if (done) break;
      if (buf === null) {
        buf = value;
      } else {
        buf = concat(buf, value);
      }
      buf = await this.convertSingleBuf(buf, nodeData, nodeMap);
    }
    console.log(`载入${nodeData.length - t2}节点,用时${Date.now() - t1}ms`);
  }

  async parseFromJsonDoc(versionList) {
    // 更新树
    let update = false;
    if (Array.isArray(versionList)) {
      if (this._localOpWait) {
        this._waitUpdate = versionList;
        return;
      }
      versionList = this.convertVersionList(versionList);
      // 基于OTS的树
      if (this._versionList === null) {
        // 第一次更新
        // this._propList = this._network.call('/docapi/getAllTempAndStatusProp', {
        //   method: 'POST',
        //   data: {
        //     org_id: this._org_id,
        //   },
        // });
        // if (this._role === 7 && this._dataType > 3 && this._org_id !== '432CD10BFEF511EA9A4A7CD30AB8A430' && this._org_id !== 'B6835ADFF64711EA9F1D7085C2D76860') this._dataType = 3;
        if (this._dataType > 3) {
          try {
            const data_info = (
              await this._network.call('/api/getOrgDataInfo', {
                method: 'POST',
                data: {
                  org_id: this._org_id,
                },
              })
            ).data;
            if (!data_info) {
              this._dataType = 3;
            } else {
              if (data_info.patch_version && data_info.patch_version > data_info.version)
                data_info.version = data_info.patch_version;
              const iv = data_info.iv ? unhex(data_info.iv) : null;
              let call1 = this._network.call(data_info.url, { method: 'GET' });
              let call2 = data_info.patch_url
                ? this._network.call(data_info.patch_url, { method: 'GET' })
                : null;
              let call3 =
                data_info.sec_key || !iv
                  ? null
                  : this._network.call('/docapi/getNodeSecKey', {
                      method: 'POST',
                      data: {
                        org_id: this._org_id,
                      },
                    });
              const ov = data_info.version;
              const nv = Math.max(...versionList);
              let change =
                nv > ov
                  ? this._network.call('/docapi/getChange', {
                      method: 'POST',
                      data: {
                        org_id: this._org_id,
                        old_version: versionList.map(() => data_info.version),
                        ov,
                        new_version: versionList,
                        nv,
                        content: 'delta',
                        noVer: true,
                      },
                    })
                  : null;
              const nodeData = [];
              const nodeMap = {};
              const data = (await call1).getReader();
              const data2 = data_info.patch_url ? (await call2).getReader() : null;
              const node_sec_key = call3 === null ? {} : (await call3).data;
              if (data_info.sec_key) {
                this._sec_key = {
                  sec_key: data_info.sec_key,
                  iv,
                };
              } else {
                this._sec_key = {
                  sec_hash: data_info.sec_hash,
                  node_sec_key,
                  iv,
                };
              }
              /*await this.convertBufToRaw(data);
              if (data2) await this.convertBufToRaw(data2);
              await this.convertSingleBuf(this._rawRoot, nodeData, nodeMap);
              if (Array.isArray(this._rawParent[this._rootId])) {
                for (let i = 0; i < this._rawParent[this._rootId].length; i++) {
                  await this.convertSingleBuf(this._rawParent[this._rootId][i], nodeData, nodeMap);
                }
              }*/
              await this.convertBufToJson(data, nodeData, nodeMap);
              if (data2) await this.convertBufToJson(data2, nodeData, nodeMap);
              if (change !== null) {
                change = (await change).data;
                for (let i = 0; i < change.length; i++) {
                  if (change[i].n in nodeMap) {
                    nodeData[nodeMap[change[i].n]] = change[i];
                  } else {
                    nodeMap[change[i].n] = nodeData.push(change[i]) - 1;
                  }
                }
              }
              this._expandAll = true;
              await this.updateData(nodeData);
              this._subscriberField[0] = true;
              this._loadedField[0] = true;
              this._versionList = [...versionList];
            }
            if (this._waitInit) {
              this._InitResolve();
              this._waitInit = null;
            }
          } catch (e) {
            console.error(e);
            this._dataType = 3;
          }
        }
        if (this._dataType <= 3) {
          if (this._loadByLayer === 1) {
            this._subscriberField[0] = true;
            this._subscriberField[1] = true;
            const field = await this._network.call('/docapi/getField', {
              method: 'POST',
              data: {
                org_id: this._org_id,
                field: [0, 1],
                version: versionList,
                noVer: true,
                content: 'delta',
              },
            });
            // this._propList = await this._propList;
            if (field !== NetWorkError) {
              await this.updateData(field.data);
              update = true;
              this._versionList = [...versionList];
            } else {
              this._waitUpdate = versionList;
              return;
            }
            this._loadedField[0] = true;
            this._loadedField[1] = true;
            if (this._waitInit) {
              this._InitResolve();
              this._waitInit = null;
            }
            await this.expand(this._rootId, 1, false);
            update = true;
          } else if (this._loadByLayer === 2) {
            const field = await this._network.call('/docapi/getChildren', {
              method: 'POST',
              data: {
                org_id: this._org_id,
                node_id: this._rootId,
                self: true,
                noVer: true,
                retCn: true,
                content: 'delta',
              },
            });
            if (field !== NetWorkError) {
              await this.updateData(field.data);
              update = true;
              this._versionList = [...versionList];
            } else {
              this._waitUpdate = versionList;
              return;
            }
          } else {
            this._subscriberField[0] = true;
            this._subscriberField[1] = true;
            this._subscriberField[2] = true;
            const field = await this._network.call('/docapi/getField', {
              method: 'POST',
              data: {
                org_id: this._org_id,
                field: [0, 1, 2],
                version: versionList,
                noVer: true,
                content: 'delta',
              },
            });
            // this._propList = await this._propList;
            if (field !== NetWorkError) {
              await this.updateData(field.data);
              update = true;
              this._versionList = [...versionList];
            } else {
              this._waitUpdate = versionList;
              return;
            }
            this._loadedField[0] = true;
            this._loadedField[1] = true;
            this._loadedField[2] = true;
          }
          if (this._waitInit) {
            this._InitResolve();
            this._waitInit = null;
          }
          if (this._role === 7) await this.expandAll();
        }
      } else {
        if (!this._v) this._v = Math.max(...this._versionList);
        // 增量更新
        const filedData = {};
        const clean = {};
        /*if (this._subscriberField[2] && versionList[2] - this._versionList[2] > 100) {
          filedData[2] = this._network.call('/docapi/getField', {
            method: 'POST',
            data: {
              org_id: this._org_id,
              field: 2,
              version: versionList,
              noVer: true,
            },
          });
          clean[2] = true;
        }*/
        const old_version = Math.max(...this._versionList);
        const new_version = Math.max(...versionList);
        if (old_version < new_version) {
          this._v = new_version;
          const data = await this._network.call('/docapi/getChange', {
            method: 'POST',
            data: {
              org_id: this._org_id,
              old_version: this._versionList,
              ov: Math.max(...this._versionList),
              new_version: versionList,
              nv: Math.max(...versionList),
              content: 'delta',
              noVer: true,
            },
          });
          if (data !== NetWorkError) {
            await this.updateData(data.data);
            update = true;
          } else {
            this._waitUpdate = versionList;
            return;
          }
          for (let field in this._subscriberField) {
            if (typeof versionList[field] === 'number') {
              this._versionList[field] = versionList[field];
            }
          }
          // 获取新增区域
          if (this._versionList.length < versionList.length) {
            for (let i = this._versionList.length; i < versionList.length; i++) {
              filedData[i] = this._network.call('/docapi/getField', {
                method: 'POST',
                data: {
                  org_id: this._org_id,
                  field: i,
                  version: versionList,
                  noVer: true,
                  content: 'delta',
                },
              });
              this._subscriberField[i] = true;
              clean[i] = true;
              this._versionList.push(versionList[i]);
            }
          }
          for (let field in filedData) {
            const data = await filedData[field];
            if (data === NetWorkError) {
              this._waitUpdate = versionList;
              return;
            }
            if (field in clean) this.cleanField(parseInt(field));
            await this.updateData(data.data);
            update = true;
            if (field in clean) this._loadedField[parseInt(field)] = true;
            /*for (let j = 0; j < data.data.length; j++) {
              if (data.data[j].p in this._childrenCache) delete this._childrenCache[data.data[j].p];
              if (data.data[j].n in this._childrenCache) delete this._childrenCache[data.data[j].n];
            }
            if (this._role === 7) delete this._childrenCache[this._rootId];*/
          }
        }
      }
    } else {
      // 基于ShareDB的树 (已废弃)
      throw Error('已废弃的树类型');
      /*this._data = this.treeToMap(versionList, this._org_id);
      if (this._rootId === null) this._rootId = versionList.id;
      if (this._toBeSortId === null) this._toBeSortId = this.getToBeSortId(versionList);
      this._childrenCache = {};
      update = true;*/
    }
    console.log('parseFromJsonDoc end');
    if (update)
      this._listen.change.forEach((cb) => {
        cb(this);
      });
  }

  async updateNode(node_id, draft = false) {
    for (let i = 0; i < 60; i++) {
      const data = await this._network.call('/docapi/getNodeNew', {
        method: 'POST',
        data: {
          org_id: this._org_id,
          node_id,
        },
      });
      if (data !== NetWorkError && data.data?.length) {
        let f = true;
        if (!draft) {
          for (const node of data.data) {
            if (node.f === -2) {
              f = false;
              break;
            }
          }
        }
        await this.updateData(data.data);
        if (f) {
          return true;
        }
      }
      await sleep(1_000);
    }
    return false;
  }

  getToBeSort() {
    // 获取待整理
    return this.getNode(this._toBeSortId);
  }

  getRoot() {
    // 获取根节点
    return this.getNode(this._rootId);
  }

  async getDraft() {
    if (this._waitInit) await this._waitInit;
    if (this._localOpWait) {
      this._waitRecycle = true;
      return;
    }
    if (Array.isArray(this._versionList)) {
      if (!this._loadedField[-2]) {
        // 获取草稿箱
        this._subscriberField[-2] = true;
        const field = await this._network.call('/docapi/getDraft', {
          method: 'POST',
          data: {
            org_id: this._org_id,
            content: 'delta',
          },
        });
        if (field !== NetWorkError) {
          await this.updateData(field.data);
        } else {
          this._waitRecycle = true;
          return;
        }
        this._loadedField[2] = true;
      }
    }
    const ret = [];
    const draftPid = null;
    for (let node_id in this._data) {
      if (
        this._data[node_id].p === draftPid &&
        this._data[node_id].f === -2 &&
        this.isManage(this._data[node_id].e)
      ) {
        ret.push(node_id);
      }
    }
    return ret.map((a) => this.getNode(a).toAntDTreeData([], null, false));
  }

  async getRecycle() {
    if (this._role === 7) return true;
    if (this._waitInit) await this._waitInit;
    if (this._localOpWait) {
      this._waitRecycle = true;
      return;
    }
    if (Array.isArray(this._versionList)) {
      if (!this._loadedField[2]) {
        // 获取回收站
        this._subscriberField[2] = true;
        const field = await this._network.call('/docapi/getField', {
          method: 'POST',
          data: {
            org_id: this._org_id,
            field: 2,
            noVer: true,
            content: 'delta',
          },
        });
        if (field !== NetWorkError) {
          await this.updateData(field.data);
        } else {
          this._waitRecycle = true;
          return;
        }
        this._loadedField[2] = true;
      }
    }
    const ret = [];
    const deletePid = this._deletePid;
    for (let node_id in this._data) {
      if (
        this._data[node_id].p === deletePid &&
        this._data[node_id].f === 2 &&
        this.isManage(this._data[node_id].e)
      ) {
        ret.push(node_id);
      }
    }
    return ret.map((a) => this.getNode(a).toAntDTreeData([], null, false));
  }

  async expand(node_id, level = 1, update = true, u = false) {
    return true;
    if (this._role === 7) return true;
    if (this._waitInit) await this._waitInit;
    if (!node_id) return false;
    if (!Array.isArray(this._versionList)) return true;
    if (node_id in this._data) {
      if (
        typeof this._data[node_id].e._sys_filter_node === 'object' &&
        this._data[node_id].e._sys_filter_node?.constructor?.name === 'Set'
      ) {
        await this.updateFilterNode(node_id);
      }
      if (this._data[node_id].c === null) {
        if (update && u)
          this._listen.change.forEach((cb) => {
            cb(this);
          });
        return null;
      } else {
        {
          let next = this._data[node_id].c;
          const iE = new Set();
          while (next !== null && next !== undefined && !iE.has(next)) {
            iE.add(next);
            if (!(next in this._data)) {
              const field =
                next === this._data[node_id].c
                  ? await this._network.call('/docapi/getField', {
                      // 载入所有子节点
                      method: 'POST',
                      data: {
                        org_id: this._org_id,
                        parentId: node_id,
                        noVer: true,
                        content: 'delta',
                      },
                    })
                  : await this._network.call('/docapi/getField', {
                      // 载入漏网之鱼
                      method: 'POST',
                      data: {
                        org_id: this._org_id,
                        node_id: next,
                        noVer: true,
                        content: 'delta',
                      },
                    });
              if (field === NetWorkError) {
                this._waitExpand.push([node_id, level, update, u]);
                return null;
              }
              if (field.data?.length) {
                await this.updateData(field.data);
                u = true;
                this._subscriberField[field.data[0].f] = true;
                this._loadedField[field.data[0].f] = true;
              }
            }
            next = this._data[next]?.j;
          }
        }
        if (level > 0) {
          const node = this.findChildren(node_id);
          if (node !== null) {
            for (let i = 0; i < node.children.length; i++) {
              if (node.children[i].id in this._data && this._data[node.children[i].id].c !== null) {
                await this.expand(node.children[i].id, level - 1, false);
              }
            }
          }
        }

        if (update && u)
          this._listen.change.forEach((cb) => {
            cb(this);
          });
        return true;
      }
    } else {
      // 如果这个节点没有被加载，则展开到这个节点
      return await this.expandTo(node_id, level, update, u);
    }
  }

  async expandTo(node_id, level = 1, update = true, u = false) {
    if (this._waitInit) await this._waitInit;
    if (!node_id) return false;
    if (!Array.isArray(this._versionList)) return true;
    if (node_id in this._data) {
      return await this.expand(node_id, level, update);
    }
    let p = node_id;
    while (p && p.length === 32) {
      if (!(p in this._data)) {
        const field = await this._network.call('/docapi/getField', {
          method: 'POST',
          data: {
            org_id: this._org_id,
            node_id: p,
            noVer: true,
            content: 'delta',
          },
        });
        if (field === NetWorkError) {
          this._waitExpandTo.push([node_id, level, update, u]);
          return null;
        }
        if (field.data?.length > 0) {
          await this.updateData(field.data);
          u = true;
          this._subscriberField[field.data[0].f] = true;
          this._loadedField[field.data[0].f] = true;
        } else {
          return false;
        }
      }
      p = this._data[p]?.p;
    }
    if (node_id in this._data) {
      return await this.expand(node_id, level, update, u);
    }
    return false;
  }

  async expandToList(nodeList, level = 1) {
    for (let i = 0; i < nodeList.length; i++) {
      await this.expandTo(nodeList[i], level, false);
    }
    this._listen.change.forEach((cb) => {
      cb(this);
    });
  }

  async expandAll() {
    if (this._role === 7) return true;
    if (this._waitInit) await this._waitInit;
    if (this._expandAll) return true;
    if (!Array.isArray(this._versionList)) return true;
    if (this._rawRoot) {
      const nodeData = [];
      const nodeMap = {};
      for (const pid in this._rawParent) {
        for (let i = 0; i < this._rawParent[pid].length; i++) {
          await this.convertSingleBuf(this._rawParent[pid][i], nodeData, nodeMap);
        }
      }
      await this.updateData(nodeData);
      for (let i = 0; i < this._versionList.length; i++) {
        this._subscriberField[i] = true;
        this._loadedField[i] = true;
      }
      this._expandAll = true;
      return true;
    }
    const fieldList = [];
    for (let i = 0; i < this._versionList.length; i++) {
      if (!(i in this._loadedField)) {
        fieldList.push(i);
      }
    }
    if (fieldList.length === 0) {
      this._expandAll = true;
      return true;
    }
    const field = await this._network.call('/docapi/getField', {
      method: 'POST',
      data: {
        org_id: this._org_id,
        field: fieldList,
        noVer: true,
        content: 'delta',
      },
    });
    if (field === NetWorkError) {
      this._waitExpandAll = true;
      return null;
    }
    await this.updateData(field.data);
    this._expandAll = true;
    const wt = [];
    for (let nodeId in this._data) {
      if (
        typeof this._data[nodeId].e._sys_filter_node === 'object' &&
        this._data[nodeId].e._sys_filter_node?.constructor?.name === 'Set'
      ) {
        wt.push(this.updateFilterNode(nodeId));
      }
    }
    for (let i = 0; i < this._versionList.length; i++) {
      if (!(i in this._subscriberField)) {
        this._subscriberField[i] = true;
      }
      if (!(i in this._loadedField)) {
        this._loadedField[i] = true;
      }
    }
    await Promise.all(wt);
    this._listen.change.forEach((cb) => {
      cb(this);
    });
    return true;
  }

  isChild(parentId, childId) {
    return this.hasData(childId) && this.getData(childId).p === parentId;
  }

  //判断是否为后代节点
  isPosterity(ancestorId, posterityId) {
    while (this.hasData(posterityId)) {
      if (this.getData(posterityId).p === ancestorId) {
        return true;
      }
      posterityId = this.getData(posterityId).p;
    }
    return false;
  }

  isAnc(nodeData, parentId, deep = 0) {
    const iE = new Set();
    if (deep === 0) deep = 10_000;
    let i = 0;
    let pid = nodeData.p ?? nodeData.metadata?.p;
    while (!iE.has(pid) && i < deep) {
      if (pid === parentId) return true;
      iE.add(pid);
      i++;
      if (!this.hasData(pid)) return false;
      nodeData = this.getNode(pid);
      pid = nodeData.metadata.p;
    }
    return false;
  }

  isHide(prop) {
    if (this.isSwitch(prop)) return false;
    if (`_sys_${this._client}_hide` in prop) return true;
    if (this._role === 1 || this._role === 3) return false;
    if ('_sys_public' in prop && prop._sys_public) return false;
    if ('_sys_user_acl' in prop) {
      if (this._accountId in prop._sys_user_acl && prop._sys_user_acl[this._accountId][ACT.不可见])
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_user_acl &&
          prop._sys_user_acl[this._groupIdList[i]][ACT.不可见]
        )
          return true;
      }
      if (
        this._accountId in prop._sys_user_acl &&
        prop._sys_user_acl[this._accountId][ACT.文档查看]
      )
        return false;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_user_acl &&
          prop._sys_user_acl[this._groupIdList[i]][ACT.文档查看]
        )
          return false;
      }
    }
    if ('_sys_group_acl' in prop) {
      if (
        this._accountId in prop._sys_group_acl &&
        prop._sys_group_acl[this._accountId][ACT.不可见]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_group_acl &&
          prop._sys_group_acl[this._groupIdList[i]][ACT.不可见]
        )
          return true;
      }
    }
    if ('_sys_parent_acl' in prop) {
      if (
        this._accountId in prop._sys_parent_acl &&
        prop._sys_parent_acl[this._accountId][ACT.不可见]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_parent_acl &&
          prop._sys_parent_acl[this._groupIdList[i]][ACT.不可见]
        )
          return true;
      }
      if (
        this._accountId in prop._sys_parent_acl &&
        prop._sys_parent_acl[this._accountId][ACT.文档查看]
      )
        return false;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_parent_acl &&
          prop._sys_parent_acl[this._groupIdList[i]][ACT.文档查看]
        )
          return false;
      }
    }
    return this._role === 7;
  }

  isManage(prop) {
    if (this._role === 1 || this._role === 3) return true;
    if ('_sys_user_acl' in prop) {
      if (
        this._accountId in prop._sys_user_acl &&
        prop._sys_user_acl[this._accountId][ACT.大纲管理]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_user_acl &&
          prop._sys_user_acl[this._groupIdList[i]][ACT.大纲管理]
        )
          return true;
      }
    }
    if ('_sys_group_acl' in prop) {
      if (
        this._accountId in prop._sys_group_acl &&
        prop._sys_group_acl[this._accountId][ACT.大纲管理]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_group_acl &&
          prop._sys_group_acl[this._groupIdList[i]][ACT.大纲管理]
        )
          return true;
      }
    }
    if ('_sys_parent_acl' in prop) {
      if (
        this._accountId in prop._sys_parent_acl &&
        prop._sys_parent_acl[this._accountId][ACT.大纲管理]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_parent_acl &&
          prop._sys_parent_acl[this._groupIdList[i]][ACT.大纲管理]
        )
          return true;
      }
    }
    return false;
  }

  // 获取任务负责人参与者
  getTarget(prop) {
    const ret = {};
    if (
      '_sys_task_status' in prop &&
      typeof prop._sys_task_status === 'object' &&
      prop._sys_task_status !== null &&
      'prop' in prop._sys_task_status &&
      Array.isArray(prop._sys_task_status.prop) &&
      prop._sys_task_status.prop.length >= 4
    ) {
      for (let i = 0; i < 2; i++) {
        if (typeof prop._sys_task_status.prop[i] === 'string') {
          ret[prop._sys_task_status.prop[i]] = true;
        } else if (Array.isArray(prop._sys_task_status.prop[i])) {
          for (let j = 0; j < prop._sys_task_status.prop[i].length; j++) {
            ret[prop._sys_task_status.prop[i][j]] = true;
          }
        }
      }
    } else if (
      '_sys_actions' in prop &&
      Array.isArray(prop._sys_actions) &&
      prop._sys_actions.length > 0
    ) {
      for (let role in prop._sys_actions[0]._assigneeId) {
        if (Array.isArray(prop._sys_actions[0]._assigneeId[role])) {
          for (let i = 0; i < prop._sys_actions[0]._assigneeId[role].length; i++) {
            ret[prop._sys_actions[0]._assigneeId[role][i]] = true;
          }
        }
      }
    }
    return ret;
  }

  isRead(prop) {
    const noPermissionUserCanRead =
      !this._orgOption?.['仅新增成员可以看见一次性引用的数据源'] &&
      this._template[prop._sys_temp?.[0]]?.temp_option?.noPermissionUserCanRead;
    if (
      noPermissionUserCanRead ||
      this._template[prop._sys_temp?.[0]]?.temp_option?.isWorkOrder ||
      this._template[prop._sys_temp?.[0]]?.temp_option?.checkRead
    ) {
      if (this._role === 1 || this._role === 3) return true;
      if ('_sys_public' in prop && prop._sys_public) return true;
      const aclSetList = {
        ...('_sys_parent_acl' in prop ? prop._sys_parent_acl : {}),
        ...('_sys_user_acl' in prop ? prop._sys_user_acl : {}),
        ...('_sys_group_acl' in prop ? prop._sys_group_acl : {}),
      };
      if (this._accountId in aclSetList) {
        if (aclSetList[this._accountId][ACT.不可见]) return false;
        if (aclSetList[this._accountId][ACT.大纲管理]) return true;
      }
      if ('_sys_hide' in prop && prop._sys_hide) return false;
      for (const group_id of this._groupIdList) {
        if (group_id in aclSetList) {
          if (aclSetList[group_id][ACT.不可见]) return false;
        }
      }
      const targetList = this.getTarget(prop);
      if (this._accountId in targetList) return true;
      if (this._accountId in aclSetList) {
        if (aclSetList[this._accountId][ACT.大纲编辑]) return true;
        if (aclSetList[this._accountId][ACT.修改状态]) return true;
        if (aclSetList[this._accountId][ACT.文档查看]) return true;
        if (aclSetList[this._accountId][ACT.文档编辑]) return true;
      }
      for (const group_id of this._groupIdList) {
        if (group_id in aclSetList) {
          if (aclSetList[group_id][ACT.大纲编辑]) return true;
          if (aclSetList[group_id][ACT.修改状态]) return true;
          if (aclSetList[group_id][ACT.文档查看]) return true;
          if (aclSetList[group_id][ACT.文档编辑]) return true;
        }
      }
      return this._role !== 7;
    } else {
      return true;
    }
  }

  isEditor(prop) {
    if (prop._sys_readonly || prop._sys_statusonly) return false;
    if (this._role === 1 || this._role === 3) return true;
    if (prop._sys_na_readonly || prop._sys_na_statusonly) return false;
    if (this._role === 4) return true;
    if (this.isManage(prop)) return true;
    /*const targetList = this.getTarget(prop);
    if (this._accountId in targetList) return true;
    for (let i = 0; i < this._groupIdList.length; i++) {
      if (this._groupIdList[i] in targetList) return true;
    }*/
    if ('_sys_user_acl' in prop) {
      if (
        this._accountId in prop._sys_user_acl &&
        prop._sys_user_acl[this._accountId][ACT.大纲编辑]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_user_acl &&
          prop._sys_user_acl[this._groupIdList[i]][ACT.大纲编辑]
        )
          return true;
      }
    }
    if ('_sys_group_acl' in prop) {
      if (
        this._accountId in prop._sys_group_acl &&
        prop._sys_group_acl[this._accountId][ACT.大纲编辑]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_group_acl &&
          prop._sys_group_acl[this._groupIdList[i]][ACT.大纲编辑]
        )
          return true;
      }
    }
    if ('_sys_parent_acl' in prop) {
      if (
        this._accountId in prop._sys_parent_acl &&
        prop._sys_parent_acl[this._accountId][ACT.大纲编辑]
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_parent_acl &&
          prop._sys_parent_acl[this._groupIdList[i]][ACT.大纲编辑]
        )
          return true;
      }
    }
    return false;
  }

  isSwitch(prop) {
    if (prop._sys_readonly) return false;
    if (this._role === 1 || this._role === 3) return true;
    if (prop._sys_na_readonly) return false;
    if (this.isEditor(prop)) return true;
    const targetList = this.getTarget(prop);
    if (this._accountId in targetList) return true;
    for (let i = 0; i < this._groupIdList.length; i++) {
      if (this._groupIdList[i] in targetList) return true;
    }
    if ('_sys_user_acl' in prop) {
      if (
        this._accountId in prop._sys_user_acl &&
        (prop._sys_user_acl[this._accountId][ACT.大纲编辑] ||
          prop._sys_user_acl[this._accountId][ACT.修改状态])
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_user_acl &&
          (prop._sys_user_acl[this._groupIdList[i]][ACT.大纲编辑] ||
            prop._sys_user_acl[this._groupIdList[i]][ACT.修改状态])
        )
          return true;
      }
    }
    if ('_sys_group_acl' in prop) {
      if (
        this._accountId in prop._sys_group_acl &&
        (prop._sys_group_acl[this._accountId][ACT.大纲编辑] ||
          prop._sys_group_acl[this._accountId][ACT.修改状态])
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_group_acl &&
          (prop._sys_group_acl[this._groupIdList[i]][ACT.大纲编辑] ||
            prop._sys_group_acl[this._groupIdList[i]][ACT.修改状态])
        )
          return true;
      }
    }
    if ('_sys_parent_acl' in prop) {
      if (
        this._accountId in prop._sys_parent_acl &&
        (prop._sys_parent_acl[this._accountId][ACT.大纲编辑] ||
          prop._sys_parent_acl[this._accountId][ACT.修改状态])
      )
        return true;
      for (let i = 0; i < this._groupIdList.length; i++) {
        if (
          this._groupIdList[i] in prop._sys_parent_acl &&
          (prop._sys_parent_acl[this._groupIdList[i]][ACT.大纲编辑] ||
            prop._sys_parent_acl[this._groupIdList[i]][ACT.修改状态])
        )
          return true;
      }
    }
    return false;
  }

  getChildrenByTitle(title, node = null) {
    // TODO: 查找title为指定值的节点
    return null;
  }

  getTitleById(nodeId) {
    return this.getData(nodeId)?.t || null;
  }

  getNodeIdByDoc(docId) {
    return docId.slice(3);
  }

  findChildren(id = '') {
    if (!id || typeof id !== 'string') return null;
    // id = id.toLocaleLowerCase();
    if (this.hasData(id)) {
      return this.getNode(id);
    }
    if (id.includes('_')) {
      const tid = id.split('_')[1];
      if (this.hasData(tid)) {
        return this.getNode(tid);
      }
    }
    return null;
  }

  findChildrenPathDoc(id = '') {
    if (typeof id !== 'string') return null;
    if (id.indexOf('_') >= 0) {
      // 虚拟节点
      return this.findChildrenPathDoc(id.split('_')[0]);
    }
    if (!this.hasData(id) || id === this._rootId) return null;
    const r = [this.getNode(id)];
    while (true) {
      id = this.getData(id).p;
      if (!!id && this.hasData(id) && id !== this._rootId) {
        r.push(this.getNode(id));
      } else {
        break;
      }
    }
    r.reverse();
    return r;
  }

  findChildrenPathKey(id = '') {
    if (typeof id !== 'string') return null;
    if (id.indexOf('_') >= 0) {
      const f = this.findChildrenPathKey(id.split('_')[0]);
      if (f === null) return null;
      f.push(id);
      return f;
    }
    const r = this.findChildrenPathDoc(id);
    if (r === null) return r;
    return r.map((a) => a.id);
  }

  /**
   * @deprecated
   * 获取模板的条件匹配规则 所过滤出来的节点数据
   */
  async getConditionMatchProps(template, templates = null) {
    let matchingProps = [];
    if (template?.template_id && template.template_id !== DEFAULT_TEMPLATE) {
      const res = await this._network.call('/docapi/getMatchProps', {
        method: 'POST',
        data: {
          org_id: this._org_id,
          temp_id: template.template_id,
        },
      });
      if (res?.status === 'ok') {
        matchingProps = res.data || [];
      }
    }
    return matchingProps;
  }

  // 获取模板选值属性选项
  // TODO matchingSource需要取所有的后代节点
  getEnumQuoteExtend(matchingSource = '', matchingProp = [], matchingTemplate = {}) {
    const matchingProps = [];
    if (Array.isArray(matchingProp) && matchingProp.length) {
      const sourceNode = this.findChildren(matchingSource);
      if (!!sourceNode && sourceNode.children?.length > 0) {
        const temp_id = matchingTemplate.template_id;
        if (!temp_id) return matchingProps;
        for (let node of sourceNode.children) {
          if (
            !Array.isArray(node.prop._sys_temp) ||
            node.prop._sys_temp[0] !== temp_id ||
            !Array.isArray(node.prop._sys_temp[1])
          )
            continue;
          const temp_prop = node.prop._sys_temp[1];
          matchingProp?.map((x) => {
            const propIndex = x.split('-')?.length > 1 ? Number(x.split('-')[1]) : null;
            if (Number.isFinite(propIndex) && matchingTemplate.prop.length > propIndex) {
              if (Array.isArray(temp_prop[propIndex])) {
                temp_prop[propIndex].map((x) => {
                  if (!~matchingProps.indexOf(x)) {
                    matchingProps.push(x);
                  }
                });
              } else if (!!temp_prop[propIndex] && !~matchingProps.indexOf(temp_prop[propIndex])) {
                matchingProps.push(temp_prop[propIndex]);
              }
            }
          });
        }
      }
    }
    return matchingProps;
  }

  // 通过当前操作的属性 获取所对应的条件匹配数据
  getConditionMatchPropsData({
    handleDataIndex, // 当前操作的属性index
    propData, // 当前的属性数据
    userMap, // 用户信息map { userid:{ nick_name:xxxx } }
    template, // 当前模板
    templateList = null, // 空间模板列表
    matchConfig, // 可选，已经通过getConditionMatchProps匹配的数据
    creator = null, //创建者
    title = '', //标题
    createTime = 0,
    currentUserId = '',
  }) {
    const [newData, changedFields] = conditionMatchPropsData({
      handleDataIndex, // 当前操作的属性index
      propData, // 当前的属性数据
      userMap, // 用户信息map { userid:{ nick_name:xxxx } }
      template, // 当前模板
      templateList, // 空间模板列表
      matchConfig, // 可选，已经通过getConditionMatchProps匹配的数据
      creator, //创建者
      title,
      changedFields: [handleDataIndex],
      createTime,
      currentUserId,
    });
    return [newData, changedFields];
  }

  /**
   * @deprecated
   * 根据条件匹配，获得选值属性的选值范围
   */
  getConditionExtend({
    propData, // 当前的属性数据
    dataIndex, // 当前的属性index
    dataType, // 当前的属性type
    matchConfig, // 已经通过getConditionMatchProps匹配的数据
    creator, //创建者
    title = '', // 标题
  }) {
    return getTempPropEnumOption({
      propData,
      dataIndex,
      dataType,
      matchConfig,
      creator,
      title,
    });
  }

  getNodeTreeSerialNumber(nodeList = []) {
    let copy = false;
    for (let i = 0; i < nodeList.length; i++) {
      if (typeof nodeList[i] === 'string') {
        if (!copy) {
          copy = true;
          nodeList = [...nodeList];
        }
        if (this.hasData(nodeList[i])) {
          nodeList[i] = this.getNode(nodeList[i]);
        }
      }
    }
    nodeList = nodeList.filter((node) => typeof node === 'object' && !node?.delete);
    /** @type {{string: PiNode}} */
    const nodeIdMap = {};
    for (/** @type {Node} */ const node of nodeList) {
      nodeIdMap[node.id] = node;
    }
    /** @type {{string: Array<PiNode>}} */
    const childrenMap = {};
    /** @type {Array<string>} */
    const root = [];
    /** @type {Set<string>} */
    const iE = new Set();
    // 计算子节点和root
    for (/** @type {Node} */ const node of nodeList) {
      if (iE.has(node.id)) continue;
      iE.add(node.id);
      /** @type {PiNode} */
      let p = node;
      while (p.data.p in nodeIdMap) {
        const pid = p.data.p;
        if (!(pid in childrenMap)) childrenMap[pid] = [];
        if (!iE.has(pid)) iE.add(pid);
        childrenMap[pid].push(p);
        p = p.getParentNode();
      }
      if (!root.includes(p.id)) root.push(p.id);
    }
    // 子节点排序
    for (const pid in childrenMap) {
      childrenMap[pid].sort((a, b) => a.index - b.index);
    }
    // 获取root的公共祖先
    if (root.length === 0) return {};
    let pid = root[0];
    while (pid && pid !== this._deletePid && this.hasData(pid)) {
      let f = false;
      for (const root_id of root) {
        if (!this.isAnc(nodeIdMap[root_id], pid)) {
          f = true;
          break;
        }
      }
      if (f) {
        pid = this.getNode(pid).data.p;
      } else {
        break;
      }
    }
    // root节点排序
    const rootSerialId = { [pid]: '' };
    for (const root_id of root) {
      let pid = root_id;
      const pid_serial = [];
      while (!(pid in rootSerialId) && this.hasData(pid)) {
        pid_serial.push(pid);
        pid = this.getNode(pid).data.p;
      }
      pid_serial.reverse();
      for (const pid of pid_serial) {
        rootSerialId[pid] = rootSerialId[this.getNode(pid).data.p] + `/${this.getNode(pid).index}`;
      }
    }
    textSort(root, (n) => rootSerialId[n]);
    // 生成最终的序列
    const ret = {};
    for (let i = 0; i < root.length; i++) {
      ret[root[i]] = (i + 1).toString();
    }
    for (const id in childrenMap) {
      let pid = id;
      const pid_serial = [];
      while (!(pid in ret)) {
        pid_serial.push(pid);
        pid = this.getNode(pid).data.p;
      }
      pid_serial.reverse();
      for (const pid of pid_serial) {
        if (!(pid in ret)) {
          ret[pid] =
            ret[this.getNode(pid).data.p] +
            `.${childrenMap[this.getNode(pid).data.p].findIndex((n) => n === pid)}`;
        }
      }
      for (let i = 0, j = 0; i < childrenMap[id].length; i++) {
        if (!(childrenMap[id][i].id in ret)) {
          ret[childrenMap[id][i].id] = ret[id] + `.${++j}`;
        }
      }
    }
    return ret;
  }

  sortNode(nodeList, orderByKey, orderDesc) {
    if (!nodeList?.length) return [];
    let ret = [];
    if (typeof nodeList[0] === 'string') {
      for (const node_id of nodeList) {
        ret.push(this.getNode(node_id));
      }
    } else {
      ret.push.apply(ret, nodeList);
    }
    const osp = orderByKey.split('_');
    switch (osp[0]) {
      case 'treeLevel':
        const treeLevelMap = this.getNodeTreeSerialNumber(ret);
        for (const n of ret) {
          n.treeLevelId = treeLevelMap[n.id];
        }
        textSort(ret, (n) => n.treeLevelId);
        break;
      case '':
        if (osp[1] === 'sys') {
          switch (osp[2]) {
            case 'updateTime':
              ret.sort((nodeA, nodeB) => nodeB.metadata.m - nodeA.metadata.m);
              break;
            case 'createTime':
              ret = ret.sort((nodeA, nodeB) => nodeA.prop[orderByKey] - nodeB.prop[orderByKey]);
              break;
          }
        }
        break;
      case 'templateStatus':
        ret.sort((nodeA, nodeB) => nodeA.tempInfo.status - nodeB.tempInfo.status);
        break;
      case 'templateProp':
        {
          const propIndex = parseInt(osp[2]);
          textSort(ret, (n) => {
            const r = n.metadata.e._sys_temp?.[1]?.[propIndex];
            if (typeof r !== 'string') return JSON.stringify(r);
            return r;
          });
        }
        break;
      case 'templateStatusPropBase': {
        const propIndex = parseInt(osp[1]);
        textSort(ret, (n) => {
          const r = n.metadata.e._sys_task_status?.prop?.[propIndex];
          if (typeof r !== 'string') return JSON.stringify(r);
          return r;
        });
      }
    }
    if (orderDesc) ret.reverse();
    return ret;
  }
}

// shareDB兼容层`
shareDbCompat(NodeManager);
// 模板属性兼容主题/任务为默认模板属性
getTempAttr(PiNode);

// 创建新的节点编辑器
PiNode.prototype.createNodeEditor = async function ({ userMap, onWarn, matchInfo }) {
  return await NodeEditor.createEmpty(this, { userMap, onWarn, matchInfo });
};
// 获取节点编辑器
PiNode.prototype.getNodeEditor = async function ({ userMap, onWarn, matchInfo }) {
  return await NodeEditor.createWithNode(this, { userMap, onWarn, matchInfo });
};

module.exports = { NodeManager, PiNode, ClientList, FILTER_SELF_ID };
